import { tmsApi as api } from "./tmsApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getApiAdmintoolMarkets: build.query<
      GetApiAdmintoolMarketsApiResponse,
      GetApiAdmintoolMarketsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admintool/markets`,
        params: {
          recursive: queryArg.recursive,
          languageId: queryArg.languageId,
        },
      }),
    }),
    postApiAdmintoolMarkets: build.mutation<
      PostApiAdmintoolMarketsApiResponse,
      PostApiAdmintoolMarketsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admintool/markets`,
        method: "POST",
        body: queryArg.adminNatCodesNewMarketRequest,
      }),
    }),
    deleteApiAdmintoolMarketsByMarketId: build.mutation<
      DeleteApiAdmintoolMarketsByMarketIdApiResponse,
      DeleteApiAdmintoolMarketsByMarketIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admintool/markets/${queryArg.marketId}`,
        method: "DELETE",
      }),
    }),
    getApiAdmintoolMarketsByMarketId: build.query<
      GetApiAdmintoolMarketsByMarketIdApiResponse,
      GetApiAdmintoolMarketsByMarketIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admintool/markets/${queryArg.marketId}`,
        params: {
          recursive: queryArg.recursive,
          languageId: queryArg.languageId,
        },
      }),
    }),
    putApiAdmintoolMarketsByMarketId: build.mutation<
      PutApiAdmintoolMarketsByMarketIdApiResponse,
      PutApiAdmintoolMarketsByMarketIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admintool/markets/${queryArg.marketId}`,
        method: "PUT",
        body: queryArg.adminNatCodesMarketDescription,
        params: {
          replace: queryArg.replace,
        },
      }),
    }),
    getApiAdmintoolMarketsByMarketIdFactoryCodeAttrs: build.query<
      GetApiAdmintoolMarketsByMarketIdFactoryCodeAttrsApiResponse,
      GetApiAdmintoolMarketsByMarketIdFactoryCodeAttrsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admintool/markets/${queryArg.marketId}/factory_code_attrs`,
      }),
    }),
    deleteApiAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemId:
      build.mutation<
        DeleteApiAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemIdApiResponse,
        DeleteApiAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admintool/markets/${queryArg.marketId}/factory_code_attrs/${queryArg.factoryCodeItemId}`,
          method: "DELETE",
        }),
      }),
    postApiAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemId:
      build.mutation<
        PostApiAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemIdApiResponse,
        PostApiAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admintool/markets/${queryArg.marketId}/factory_code_attrs/${queryArg.factoryCodeItemId}`,
          method: "POST",
          body: queryArg.factoryCodeAttributeRequest,
        }),
      }),
    putApiAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemId:
      build.mutation<
        PutApiAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemIdApiResponse,
        PutApiAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admintool/markets/${queryArg.marketId}/factory_code_attrs/${queryArg.factoryCodeItemId}`,
          method: "PUT",
          body: queryArg.factoryCodeAttributeRequest,
        }),
      }),
    postApiAdmintoolMarketsByMarketIdGroups: build.mutation<
      PostApiAdmintoolMarketsByMarketIdGroupsApiResponse,
      PostApiAdmintoolMarketsByMarketIdGroupsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admintool/markets/${queryArg.marketId}/groups`,
        method: "POST",
        body: queryArg.adminNatCodesNewGroupRequest,
      }),
    }),
    deleteApiAdmintoolMarketsByMarketIdGroupsAndGroupId: build.mutation<
      DeleteApiAdmintoolMarketsByMarketIdGroupsAndGroupIdApiResponse,
      DeleteApiAdmintoolMarketsByMarketIdGroupsAndGroupIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admintool/markets/${queryArg.marketId}/groups/${queryArg.groupId}`,
        method: "DELETE",
      }),
    }),
    getApiAdmintoolMarketsByMarketIdGroupsAndGroupId: build.query<
      GetApiAdmintoolMarketsByMarketIdGroupsAndGroupIdApiResponse,
      GetApiAdmintoolMarketsByMarketIdGroupsAndGroupIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admintool/markets/${queryArg.marketId}/groups/${queryArg.groupId}`,
        params: {
          recursive: queryArg.recursive,
          languageId: queryArg.languageId,
        },
      }),
    }),
    putApiAdmintoolMarketsByMarketIdGroupsAndGroupId: build.mutation<
      PutApiAdmintoolMarketsByMarketIdGroupsAndGroupIdApiResponse,
      PutApiAdmintoolMarketsByMarketIdGroupsAndGroupIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admintool/markets/${queryArg.marketId}/groups/${queryArg.groupId}`,
        method: "PUT",
        body: queryArg.adminNatCodesGroupDescription,
        params: {
          replace: queryArg.replace,
        },
      }),
    }),
    postApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamilies: build.mutation<
      PostApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesApiResponse,
      PostApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admintool/markets/${queryArg.marketId}/groups/${queryArg.groupId}/families`,
        method: "POST",
        body: queryArg.adminNatCodesNewFamilyRequest,
      }),
    }),
    deleteApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyId:
      build.mutation<
        DeleteApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdApiResponse,
        DeleteApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admintool/markets/${queryArg.marketId}/groups/${queryArg.groupId}/families/${queryArg.familyId}`,
          method: "DELETE",
        }),
      }),
    getApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyId:
      build.query<
        GetApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdApiResponse,
        GetApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admintool/markets/${queryArg.marketId}/groups/${queryArg.groupId}/families/${queryArg.familyId}`,
          params: {
            recursive: queryArg.recursive,
            languageId: queryArg.languageId,
          },
        }),
      }),
    putApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyId:
      build.mutation<
        PutApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdApiResponse,
        PutApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admintool/markets/${queryArg.marketId}/groups/${queryArg.groupId}/families/${queryArg.familyId}`,
          method: "PUT",
          body: queryArg.adminNatCodesFamilyDescription,
          params: {
            replace: queryArg.replace,
          },
        }),
      }),
    postApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutions:
      build.mutation<
        PostApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsApiResponse,
        PostApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admintool/markets/${queryArg.marketId}/groups/${queryArg.groupId}/families/${queryArg.familyId}/executions`,
          method: "POST",
          body: queryArg.adminNatCodesNewCodeRequest,
        }),
      }),
    deleteApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionId:
      build.mutation<
        DeleteApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionIdApiResponse,
        DeleteApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admintool/markets/${queryArg.marketId}/groups/${queryArg.groupId}/families/${queryArg.familyId}/executions/${queryArg.executionId}`,
          method: "DELETE",
        }),
      }),
    getApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionId:
      build.query<
        GetApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionIdApiResponse,
        GetApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admintool/markets/${queryArg.marketId}/groups/${queryArg.groupId}/families/${queryArg.familyId}/executions/${queryArg.executionId}`,
          params: {
            languageId: queryArg.languageId,
          },
        }),
      }),
    putApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionId:
      build.mutation<
        PutApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionIdApiResponse,
        PutApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admintool/markets/${queryArg.marketId}/groups/${queryArg.groupId}/families/${queryArg.familyId}/executions/${queryArg.executionId}`,
          method: "PUT",
          body: queryArg.adminNatCodesCodeDescription,
          params: {
            replace: queryArg.replace,
          },
        }),
      }),
    getApiAdmintoolMarketsByMarketIdImportantFamiliesCountry: build.query<
      GetApiAdmintoolMarketsByMarketIdImportantFamiliesCountryApiResponse,
      GetApiAdmintoolMarketsByMarketIdImportantFamiliesCountryApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admintool/markets/${queryArg.marketId}/importantFamiliesCountry`,
      }),
    }),
    putApiAdmintoolMarketsByMarketIdImportantFamiliesCountry: build.mutation<
      PutApiAdmintoolMarketsByMarketIdImportantFamiliesCountryApiResponse,
      PutApiAdmintoolMarketsByMarketIdImportantFamiliesCountryApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admintool/markets/${queryArg.marketId}/importantFamiliesCountry`,
        method: "PUT",
        body: queryArg.importantFamiliesCountryRequest,
      }),
    }),
    getApiAdmintoolMarketsByMarketIdReferenceTrucks: build.query<
      GetApiAdmintoolMarketsByMarketIdReferenceTrucksApiResponse,
      GetApiAdmintoolMarketsByMarketIdReferenceTrucksApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admintool/markets/${queryArg.marketId}/reference_trucks`,
      }),
    }),
    postApiAdmintoolMarketsByMarketIdReferenceTrucks: build.mutation<
      PostApiAdmintoolMarketsByMarketIdReferenceTrucksApiResponse,
      PostApiAdmintoolMarketsByMarketIdReferenceTrucksApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admintool/markets/${queryArg.marketId}/reference_trucks`,
        method: "POST",
        body: queryArg.newReferenceTruckRequest,
      }),
    }),
    deleteApiAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckId:
      build.mutation<
        DeleteApiAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckIdApiResponse,
        DeleteApiAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admintool/markets/${queryArg.marketId}/reference_trucks/${queryArg.referenceTruckId}`,
          method: "DELETE",
        }),
      }),
    getApiAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckId:
      build.query<
        GetApiAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckIdApiResponse,
        GetApiAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admintool/markets/${queryArg.marketId}/reference_trucks/${queryArg.referenceTruckId}`,
        }),
      }),
    putApiAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckId:
      build.mutation<
        PutApiAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckIdApiResponse,
        PutApiAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admintool/markets/${queryArg.marketId}/reference_trucks/${queryArg.referenceTruckId}`,
          method: "PUT",
          body: queryArg.updateReferenceTruckRequest,
        }),
      }),
    postApiCava: build.mutation<PostApiCavaApiResponse, PostApiCavaApiArg>({
      query: (queryArg) => ({
        url: `/api/cava`,
        method: "POST",
        body: queryArg.cavaProvisionedRequest,
      }),
    }),
    postApiCavaByUuid: build.mutation<
      PostApiCavaByUuidApiResponse,
      PostApiCavaByUuidApiArg
    >({
      query: (queryArg) => ({
        url: `/api/cava/${queryArg.uuid}`,
        method: "POST",
        body: queryArg.cavaRequest,
      }),
    }),
    postApiCode: build.mutation<PostApiCodeApiResponse, PostApiCodeApiArg>({
      query: (queryArg) => ({
        url: `/api/code`,
        method: "POST",
        body: queryArg.manCodeRequest,
      }),
    }),
    getApiCodeById: build.query<
      GetApiCodeByIdApiResponse,
      GetApiCodeByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/code/${queryArg.id}`,
        params: {
          include_journal: queryArg.includeJournal,
        },
      }),
    }),
    getApiCodeByIdCheck: build.query<
      GetApiCodeByIdCheckApiResponse,
      GetApiCodeByIdCheckApiArg
    >({
      query: (queryArg) => ({
        url: `/api/code/${queryArg.id}/check`,
        params: {
          partPeriod: queryArg.partPeriod,
          checkAcceptanceLevel: queryArg.checkAcceptanceLevel,
          executeFinalChecks: queryArg.executeFinalChecks,
        },
      }),
    }),
    putApiCodeByIdConfiguration: build.mutation<
      PutApiCodeByIdConfigurationApiResponse,
      PutApiCodeByIdConfigurationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/code/${queryArg.id}/configuration`,
        method: "PUT",
        body: queryArg.manCodeRequest,
        params: {
          system: queryArg.system,
        },
      }),
    }),
    postApiCodeByIdCopy: build.mutation<
      PostApiCodeByIdCopyApiResponse,
      PostApiCodeByIdCopyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/code/${queryArg.id}/copy`,
        method: "POST",
      }),
    }),
    getApiCodeByIdGetTokensAndSystem: build.query<
      GetApiCodeByIdGetTokensAndSystemApiResponse,
      GetApiCodeByIdGetTokensAndSystemApiArg
    >({
      query: (queryArg) => ({
        url: `/api/code/${queryArg.id}/getTokens/${queryArg.system}`,
      }),
    }),
    putApiCodeByIdResetTokensAndSystem: build.mutation<
      PutApiCodeByIdResetTokensAndSystemApiResponse,
      PutApiCodeByIdResetTokensAndSystemApiArg
    >({
      query: (queryArg) => ({
        url: `/api/code/${queryArg.id}/resetTokens/${queryArg.system}`,
        method: "PUT",
      }),
    }),
    putApiCodeByIdSetTokens: build.mutation<
      PutApiCodeByIdSetTokensApiResponse,
      PutApiCodeByIdSetTokensApiArg
    >({
      query: (queryArg) => ({
        url: `/api/code/${queryArg.id}/setTokens`,
        method: "PUT",
        body: queryArg.tokenRequest,
      }),
    }),
    postApiConfiguration: build.mutation<
      PostApiConfigurationApiResponse,
      PostApiConfigurationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/configuration`,
        method: "POST",
        body: queryArg.ecmConfigurationTarget,
      }),
    }),
    getApiConfigurationByUuid: build.query<
      GetApiConfigurationByUuidApiResponse,
      GetApiConfigurationByUuidApiArg
    >({
      query: (queryArg) => ({
        url: `/api/configuration/${queryArg.uuid}`,
        params: {
          groupForCompatibilityCheck: queryArg.groupForCompatibilityCheck,
        },
      }),
    }),
    putApiConfigurationByUuidChangeGroupOfInterest: build.mutation<
      PutApiConfigurationByUuidChangeGroupOfInterestApiResponse,
      PutApiConfigurationByUuidChangeGroupOfInterestApiArg
    >({
      query: (queryArg) => ({
        url: `/api/configuration/${queryArg.uuid}/change_group_of_interest`,
        method: "PUT",
        params: {
          groupForCompatibilityCheck: queryArg.groupForCompatibilityCheck,
        },
      }),
    }),
    getApiConfigurationByUuidCheckBrakeRatio: build.query<
      GetApiConfigurationByUuidCheckBrakeRatioApiResponse,
      GetApiConfigurationByUuidCheckBrakeRatioApiArg
    >({
      query: (queryArg) => ({
        url: `/api/configuration/${queryArg.uuid}/check_brake_ratio`,
      }),
    }),
    getApiConfigurationByUuidCheckDvs: build.query<
      GetApiConfigurationByUuidCheckDvsApiResponse,
      GetApiConfigurationByUuidCheckDvsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/configuration/${queryArg.uuid}/check_dvs`,
      }),
    }),
    getApiConfigurationByUuidCheckOas: build.query<
      GetApiConfigurationByUuidCheckOasApiResponse,
      GetApiConfigurationByUuidCheckOasApiArg
    >({
      query: (queryArg) => ({
        url: `/api/configuration/${queryArg.uuid}/check_oas`,
        params: {
          check_type: queryArg.checkType,
        },
      }),
    }),
    getApiConfigurationByUuidCheckTires: build.query<
      GetApiConfigurationByUuidCheckTiresApiResponse,
      GetApiConfigurationByUuidCheckTiresApiArg
    >({
      query: (queryArg) => ({
        url: `/api/configuration/${queryArg.uuid}/check_tires`,
      }),
    }),
    getApiConfigurationByUuidCheckWeight: build.query<
      GetApiConfigurationByUuidCheckWeightApiResponse,
      GetApiConfigurationByUuidCheckWeightApiArg
    >({
      query: (queryArg) => ({
        url: `/api/configuration/${queryArg.uuid}/check_weight`,
      }),
    }),
    postApiConfigurationByUuidDeselectVariants: build.mutation<
      PostApiConfigurationByUuidDeselectVariantsApiResponse,
      PostApiConfigurationByUuidDeselectVariantsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/configuration/${queryArg.uuid}/deselect-variants`,
        method: "POST",
        body: queryArg.multiVariantDeselectionRequest,
        params: {
          groupForCompatibilityCheck: queryArg.groupForCompatibilityCheck,
        },
      }),
    }),
    putApiConfigurationByUuidRefresh: build.mutation<
      PutApiConfigurationByUuidRefreshApiResponse,
      PutApiConfigurationByUuidRefreshApiArg
    >({
      query: (queryArg) => ({
        url: `/api/configuration/${queryArg.uuid}/refresh`,
        method: "PUT",
      }),
    }),
    postApiConfigurationByUuidSelectVariantAndVariantId: build.mutation<
      PostApiConfigurationByUuidSelectVariantAndVariantIdApiResponse,
      PostApiConfigurationByUuidSelectVariantAndVariantIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/configuration/${queryArg.uuid}/select-variant/${queryArg["variant-id"]}`,
        method: "POST",
        body: queryArg.variantSelectionOptions,
        params: {
          groupForCompatibilityCheck: queryArg.groupForCompatibilityCheck,
        },
      }),
    }),
    postApiConfigurationByUuidSelectVariants: build.mutation<
      PostApiConfigurationByUuidSelectVariantsApiResponse,
      PostApiConfigurationByUuidSelectVariantsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/configuration/${queryArg.uuid}/select-variants`,
        method: "POST",
        body: queryArg.multiVariantSelectionRequest,
        params: {
          groupForCompatibilityCheck: queryArg.groupForCompatibilityCheck,
        },
      }),
    }),
    postApiConfigurationByUuidStepAndStep: build.mutation<
      PostApiConfigurationByUuidStepAndStepApiResponse,
      PostApiConfigurationByUuidStepAndStepApiArg
    >({
      query: (queryArg) => ({
        url: `/api/configuration/${queryArg.uuid}/step/${queryArg.step}`,
        method: "POST",
        body: queryArg.configurationStepDataOptions,
        params: {
          groupForCompatibilityCheck: queryArg.groupForCompatibilityCheck,
        },
      }),
    }),
    putApiConfigurationByUuidSwitchBaseParameters: build.mutation<
      PutApiConfigurationByUuidSwitchBaseParametersApiResponse,
      PutApiConfigurationByUuidSwitchBaseParametersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/configuration/${queryArg.uuid}/switch_base_parameters`,
        method: "PUT",
        body: queryArg.switchBaseParametersRequest,
      }),
    }),
    postApiConfigurationByUuidUndocommit: build.mutation<
      PostApiConfigurationByUuidUndocommitApiResponse,
      PostApiConfigurationByUuidUndocommitApiArg
    >({
      query: (queryArg) => ({
        url: `/api/configuration/${queryArg.uuid}/undocommit`,
        method: "POST",
        body: queryArg.configurationStepDataOptions,
      }),
    }),
    postApiConfigurationValidate: build.mutation<
      PostApiConfigurationValidateApiResponse,
      PostApiConfigurationValidateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/configuration/validate`,
        method: "POST",
        body: queryArg.validationResponse,
      }),
    }),
    postApiConvertEcmConfigByUuid: build.mutation<
      PostApiConvertEcmConfigByUuidApiResponse,
      PostApiConvertEcmConfigByUuidApiArg
    >({
      query: (queryArg) => ({
        url: `/api/convert/ecm_config/${queryArg.uuid}`,
        method: "POST",
        body: queryArg.ecmConversionTarget,
      }),
    }),
    postApiConvertMancode: build.mutation<
      PostApiConvertMancodeApiResponse,
      PostApiConvertMancodeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/convert/mancode`,
        method: "POST",
        body: queryArg.manConversionTarget,
      }),
    }),
    getApiConvertMancodeIdByUuidConvertToGdcInput: build.query<
      GetApiConvertMancodeIdByUuidConvertToGdcInputApiResponse,
      GetApiConvertMancodeIdByUuidConvertToGdcInputApiArg
    >({
      query: (queryArg) => ({
        url: `/api/convert/mancode_id/${queryArg.uuid}/convert_to_gdc_input`,
      }),
    }),
    postApiConvertTg3CodeByLanguage: build.mutation<
      PostApiConvertTg3CodeByLanguageApiResponse,
      PostApiConvertTg3CodeByLanguageApiArg
    >({
      query: (queryArg) => ({
        url: `/api/convert/tg3code/${queryArg.language}`,
        method: "POST",
        body: queryArg.tg3ConversionRequest,
        params: {
          addEmptyGroups: queryArg.addEmptyGroups,
          addEmptyFamilies: queryArg.addEmptyFamilies,
          excludeHiddenCodes: queryArg.excludeHiddenCodes,
          excludeIneffectiveCodes: queryArg.excludeIneffectiveCodes,
          applicationSegment: queryArg.applicationSegment,
          addFPCMapping: queryArg.addFpcMapping,
          viewId: queryArg.viewId,
        },
      }),
    }),
    getApiProductdataGetconfigurationtypeids: build.query<
      GetApiProductdataGetconfigurationtypeidsApiResponse,
      GetApiProductdataGetconfigurationtypeidsApiArg
    >({
      query: () => ({ url: `/api/productdata/getconfigurationtypeids` }),
    }),
    getApiProductdataGetvehicletypeids: build.query<
      GetApiProductdataGetvehicletypeidsApiResponse,
      GetApiProductdataGetvehicletypeidsApiArg
    >({
      query: () => ({ url: `/api/productdata/getvehicletypeids` }),
    }),
    getApiProductdataGetviewheadersByMarketId: build.query<
      GetApiProductdataGetviewheadersByMarketIdApiResponse,
      GetApiProductdataGetviewheadersByMarketIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/productdata/getviewheaders/${queryArg.marketId}`,
      }),
    }),
    getApiProductdataImportantFamiliesFactory: build.query<
      GetApiProductdataImportantFamiliesFactoryApiResponse,
      GetApiProductdataImportantFamiliesFactoryApiArg
    >({
      query: () => ({ url: `/api/productdata/importantFamiliesFactory` }),
    }),
    getApiProductdataMarketByMarketIdLanguageAndLanguageIdFamilies: build.query<
      GetApiProductdataMarketByMarketIdLanguageAndLanguageIdFamiliesApiResponse,
      GetApiProductdataMarketByMarketIdLanguageAndLanguageIdFamiliesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/productdata/market/${queryArg.marketId}/language/${queryArg.languageId}/families`,
        params: {
          includeOnlyLocalCodes: queryArg.includeOnlyLocalCodes,
          viewId: queryArg.viewId,
        },
      }),
    }),
    getApiProductdataMarketByMarketIdLanguages: build.query<
      GetApiProductdataMarketByMarketIdLanguagesApiResponse,
      GetApiProductdataMarketByMarketIdLanguagesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/productdata/market/${queryArg.marketId}/languages`,
      }),
    }),
    getApiProductdataMarketByMarketIdPartPeriodFromDesiredDealerDate:
      build.query<
        GetApiProductdataMarketByMarketIdPartPeriodFromDesiredDealerDateApiResponse,
        GetApiProductdataMarketByMarketIdPartPeriodFromDesiredDealerDateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/productdata/market/${queryArg.marketId}/partPeriodFromDesiredDealerDate`,
          params: {
            vehicleTypeId: queryArg.vehicleTypeId,
            desiredDealerDate: queryArg.desiredDealerDate,
          },
        }),
      }),
    getApiTg3CodeById: build.query<
      GetApiTg3CodeByIdApiResponse,
      GetApiTg3CodeByIdApiArg
    >({
      query: (queryArg) => ({ url: `/api/tg3_code/${queryArg.id}` }),
    }),
    getApiUserdataGetmarkets: build.query<
      GetApiUserdataGetmarketsApiResponse,
      GetApiUserdataGetmarketsApiArg
    >({
      query: () => ({ url: `/api/userdata/getmarkets` }),
    }),
    getApiUserdataLoad: build.query<
      GetApiUserdataLoadApiResponse,
      GetApiUserdataLoadApiArg
    >({
      query: () => ({ url: `/api/userdata/load` }),
    }),
    postApiUserdataUpdate: build.mutation<
      PostApiUserdataUpdateApiResponse,
      PostApiUserdataUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/userdata/update`,
        method: "POST",
        body: queryArg.userData,
      }),
    }),
    getApiVisualizationFetchMediumByFetchCode: build.query<
      GetApiVisualizationFetchMediumByFetchCodeApiResponse,
      GetApiVisualizationFetchMediumByFetchCodeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/visualization/fetch_medium/${queryArg.fetchCode}`,
      }),
    }),
    postApiVisualizationOrderMedium: build.mutation<
      PostApiVisualizationOrderMediumApiResponse,
      PostApiVisualizationOrderMediumApiArg
    >({
      query: (queryArg) => ({
        url: `/api/visualization/order_medium`,
        method: "POST",
        body: queryArg.visOrderRequest,
      }),
    }),
    getTokenManagement: build.query<
      GetTokenManagementApiResponse,
      GetTokenManagementApiArg
    >({
      query: () => ({ url: `/token-management` }),
    }),
    postUnittesting: build.mutation<
      PostUnittestingApiResponse,
      PostUnittestingApiArg
    >({
      query: () => ({ url: `/unittesting`, method: "POST" }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as tmsApiService };
export type GetApiAdmintoolMarketsApiResponse =
  /** status 200 OK */ AdminAllMarketsResponse;
export type GetApiAdmintoolMarketsApiArg = {
  /** Indicates if attached groups, families, and codes should also be included in the response */
  recursive?: boolean;
  /** Indicates which language should be chosen for the returned description of the market items. If no language is specified, descriptions in all available languages will be returned. If there is no description available for a certain item in the specified language, no description will be returned */
  languageId?: LanguageIsoCode;
};
export type PostApiAdmintoolMarketsApiResponse =
  /** status 201 CREATED */ AdminMarketDescriptionResponse;
export type PostApiAdmintoolMarketsApiArg = {
  adminNatCodesNewMarketRequest: AdminNatCodesNewMarketRequest;
};
export type DeleteApiAdmintoolMarketsByMarketIdApiResponse =
  /** status 200 OK */ StatusResponse;
export type DeleteApiAdmintoolMarketsByMarketIdApiArg = {
  /** Identifies the target market */
  marketId: MarketId;
};
export type GetApiAdmintoolMarketsByMarketIdApiResponse =
  /** status 200 OK */ AdminMarketDescriptionResponse;
export type GetApiAdmintoolMarketsByMarketIdApiArg = {
  /** Identifies the target market */
  marketId: MarketId;
  /** Indicates if attached groups, families, and codes should also be included in the response */
  recursive?: boolean;
  /** Indicates which language should be chosen for the returned description of the market items. If no language is specified, descriptions in all available languages will be returned. If there is no description available for a certain item in the specified language, no description will be returned */
  languageId?: LanguageIsoCode;
};
export type PutApiAdmintoolMarketsByMarketIdApiResponse =
  /** status 200 OK */ AdminMarketDescriptionResponse;
export type PutApiAdmintoolMarketsByMarketIdApiArg = {
  /** Identifies the target market */
  marketId: MarketId;
  /** Indicates whether to replace all market information or rather incorporate new information. This is helpful if e.g. a description in an additional language is to be added. */
  replace?: string;
  adminNatCodesMarketDescription: AdminNatCodesMarketDescription;
};
export type GetApiAdmintoolMarketsByMarketIdFactoryCodeAttrsApiResponse =
  /** status 200 OK */ AdminAllFactoryCodeAttributesResponse;
export type GetApiAdmintoolMarketsByMarketIdFactoryCodeAttrsApiArg = {
  /** Identifies the target market */
  marketId: MarketId;
};
export type DeleteApiAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemIdApiResponse =
  /** status 200 OK */ StatusResponse;
export type DeleteApiAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemIdApiArg =
  {
    /** Identifies the target market */
    marketId: MarketId;
    /** Identifies the target factory code attributes entry */
    factoryCodeItemId: FactoryCodeItemId;
  };
export type PostApiAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemIdApiResponse =
  /** status 200 OK */ AdminFactoryCodeAttributesResponse;
export type PostApiAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemIdApiArg =
  {
    /** Identifies the target market */
    marketId: MarketId;
    /** Identifies the target factory code attributes entry by familyId or variantId. */
    factoryCodeItemId: FactoryCodeItemId;
    factoryCodeAttributeRequest: FactoryCodeAttributeRequest;
  };
export type PutApiAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemIdApiResponse =
  /** status 200 OK */ AdminFactoryCodeAttributesResponse;
export type PutApiAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemIdApiArg =
  {
    /** Identifies the target market */
    marketId: MarketId;
    /** Identifies the target factory code attributes entry */
    factoryCodeItemId: FactoryCodeItemId;
    factoryCodeAttributeRequest: FactoryCodeAttributeRequest;
  };
export type PostApiAdmintoolMarketsByMarketIdGroupsApiResponse =
  /** status 201 CREATED */ AdminNatCodesGroupDescriptionResponse;
export type PostApiAdmintoolMarketsByMarketIdGroupsApiArg = {
  /** Identifies the target market */
  marketId: MarketId;
  adminNatCodesNewGroupRequest: AdminNatCodesNewGroupRequest;
};
export type DeleteApiAdmintoolMarketsByMarketIdGroupsAndGroupIdApiResponse =
  /** status 200 OK */ StatusResponse;
export type DeleteApiAdmintoolMarketsByMarketIdGroupsAndGroupIdApiArg = {
  /** Identifies the target market */
  marketId: MarketId;
  /** Identifies the target group */
  groupId: AdminNatCodesGroupId;
};
export type GetApiAdmintoolMarketsByMarketIdGroupsAndGroupIdApiResponse =
  /** status 200 OK */ AdminNatCodesGroupDescriptionResponse;
export type GetApiAdmintoolMarketsByMarketIdGroupsAndGroupIdApiArg = {
  /** Indicates if attached families and codes should also be included in the response */
  recursive?: boolean;
  /** Indicates which language should be chosen for the returned description of the group items. If no language is specified, descriptions in all available languages will be returned. If there is no description available for a certain item in the specified language, no description will be returned */
  languageId?: LanguageIsoCode;
  /** Identifies the target market */
  marketId: MarketId;
  /** Identifies the target group */
  groupId: AdminNatCodesGroupId;
};
export type PutApiAdmintoolMarketsByMarketIdGroupsAndGroupIdApiResponse =
  /** status 200 OK */ AdminNatCodesGroupDescriptionResponse;
export type PutApiAdmintoolMarketsByMarketIdGroupsAndGroupIdApiArg = {
  /** Identifies the target market */
  marketId: MarketId;
  /** Indicates whether to replace all group information or rather incorporate new information. This is helpful if e.g. a description in an additional language is to be added. */
  replace?: string;
  /** Identifies the target group */
  groupId: AdminNatCodesGroupId;
  adminNatCodesGroupDescription: AdminNatCodesGroupDescription;
};
export type PostApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesApiResponse =
  /** status 201 CREATED */ AdminNatCodesFamilyDescriptionResponse;
export type PostApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesApiArg = {
  /** Identifies the target market */
  marketId: MarketId;
  /** Identifies the target group */
  groupId: AdminNatCodesGroupId;
  adminNatCodesNewFamilyRequest: AdminNatCodesNewFamilyRequest;
};
export type DeleteApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdApiResponse =
  /** status 200 OK */ StatusResponse;
export type DeleteApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdApiArg =
  {
    /** Identifies the target market */
    marketId: MarketId;
    /** Identifies the target family */
    familyId: AdminNatCodesFamilyId;
    /** Identifies the target group */
    groupId: AdminNatCodesGroupId;
  };
export type GetApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdApiResponse =
  /** status 200 OK */ AdminNatCodesFamilyDescriptionResponse;
export type GetApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdApiArg =
  {
    /** Indicates if attached codes should also be included in the response */
    recursive?: boolean;
    /** Identifies the target family */
    familyId: AdminNatCodesFamilyId;
    /** Indicates which language should be chosen for the returned description of the family items. If no language is specified, descriptions in all available languages will be returned. If there is no description available for a certain item in the specified language, no description will be returned */
    languageId?: LanguageIsoCode;
    /** Identifies the target market */
    marketId: MarketId;
    /** Identifies the target group */
    groupId: AdminNatCodesGroupId;
  };
export type PutApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdApiResponse =
  /** status 200 OK */ AdminNatCodesFamilyDescriptionResponse;
export type PutApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdApiArg =
  {
    /** Indicates whether to replace all family information or rather incorporate new information. This is helpful if e.g. a description in an additional language is to be added. */
    replace?: string;
    /** Identifies the target family */
    familyId: AdminNatCodesFamilyId;
    /** Identifies the target market */
    marketId: MarketId;
    /** Identifies the target group */
    groupId: AdminNatCodesGroupId;
    adminNatCodesFamilyDescription: AdminNatCodesFamilyDescription;
  };
export type PostApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsApiResponse =
  /** status 201 CREATED */ AdminNatCodesCodeDescriptionResponse;
export type PostApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsApiArg =
  {
    /** Identifies the target market */
    marketId: MarketId;
    /** Identifies the target family */
    familyId: AdminNatCodesFamilyId;
    /** Identifies the target group */
    groupId: AdminNatCodesGroupId;
    adminNatCodesNewCodeRequest: AdminNatCodesNewCodeRequest;
  };
export type DeleteApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionIdApiResponse =
  /** status 200 OK */ StatusResponse;
export type DeleteApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionIdApiArg =
  {
    /** Identifies the target execution */
    executionId: AdminNatCodesExecutionId;
    /** Identifies the target family */
    familyId: AdminNatCodesFamilyId;
    /** Identifies the target market */
    marketId: MarketId;
    /** Identifies the target group */
    groupId: AdminNatCodesGroupId;
  };
export type GetApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionIdApiResponse =
  /** status 200 OK */ AdminNatCodesCodeDescriptionResponse;
export type GetApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionIdApiArg =
  {
    /** Identifies the target execution */
    executionId: AdminNatCodesExecutionId;
    /** Indicates which language should be chosen for the returned description of the code items. If no language is specified, descriptions in all available languages will be returned. If there is no description available for a certain item in the specified language, no description will be returned */
    languageId?: LanguageIsoCode;
    /** Identifies the target family */
    familyId: AdminNatCodesFamilyId;
    /** Identifies the target market */
    marketId: MarketId;
    /** Identifies the target group */
    groupId: AdminNatCodesGroupId;
  };
export type PutApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionIdApiResponse =
  /** status 200 OK */ AdminNatCodesCodeDescriptionResponse;
export type PutApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionIdApiArg =
  {
    /** Identifies the target execution */
    executionId: AdminNatCodesExecutionId;
    /** Indicates whether to replace all code information or rather incorporate new information. This is helpful if e.g. a description in an additional language is to be added. */
    replace?: string;
    /** Identifies the target family */
    familyId: AdminNatCodesFamilyId;
    /** Identifies the target market */
    marketId: MarketId;
    /** Identifies the target group */
    groupId: AdminNatCodesGroupId;
    adminNatCodesCodeDescription: AdminNatCodesCodeDescription;
  };
export type GetApiAdmintoolMarketsByMarketIdImportantFamiliesCountryApiResponse =
  /** status 200 OK */ ImportantFamiliesCountryResponse;
export type GetApiAdmintoolMarketsByMarketIdImportantFamiliesCountryApiArg = {
  /** Identifies the target market */
  marketId: MarketId;
};
export type PutApiAdmintoolMarketsByMarketIdImportantFamiliesCountryApiResponse =
  /** status 200 OK */ ImportantFamiliesCountryResponse;
export type PutApiAdmintoolMarketsByMarketIdImportantFamiliesCountryApiArg = {
  /** Identifies the target market */
  marketId: MarketId;
  importantFamiliesCountryRequest: ImportantFamiliesCountryRequest;
};
export type GetApiAdmintoolMarketsByMarketIdReferenceTrucksApiResponse =
  /** status 200 OK */ AdminAllReferenceTrucksResponse;
export type GetApiAdmintoolMarketsByMarketIdReferenceTrucksApiArg = {
  /** Identifies the target market */
  marketId: MarketId;
};
export type PostApiAdmintoolMarketsByMarketIdReferenceTrucksApiResponse =
  /** status 201 CREATED */ AdminReferenceTrucksResponse;
export type PostApiAdmintoolMarketsByMarketIdReferenceTrucksApiArg = {
  /** Identifies the target market */
  marketId: MarketId;
  newReferenceTruckRequest: NewReferenceTruckRequest;
};
export type DeleteApiAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckIdApiResponse =
  /** status 200 OK */ StatusResponse;
export type DeleteApiAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckIdApiArg =
  {
    /** Identifies the target market */
    marketId: MarketId;
    /** Identifies the target reference Truck */
    referenceTruckId: ReferenceTruckId;
  };
export type GetApiAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckIdApiResponse =
  /** status 200 OK */ AdminReferenceTrucksResponse;
export type GetApiAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckIdApiArg =
  {
    /** Identifies the target market */
    marketId: MarketId;
    /** Identifies the target reference Truck */
    referenceTruckId: ReferenceTruckId;
  };
export type PutApiAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckIdApiResponse =
  /** status 200 OK */ AdminReferenceTrucksResponse;
export type PutApiAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckIdApiArg =
  {
    /** Identifies the target market */
    marketId: MarketId;
    /** Identifies the target reference Truck */
    referenceTruckId: ReferenceTruckId;
    updateReferenceTruckRequest: UpdateReferenceTruckRequest;
  };
export type PostApiCavaApiResponse = /** status 200 OK */ CavaResponse;
export type PostApiCavaApiArg = {
  cavaProvisionedRequest: CavaProvisionedRequest;
};
export type PostApiCavaByUuidApiResponse = /** status 200 OK */ CavaResponse;
export type PostApiCavaByUuidApiArg = {
  uuid: EcmConfigId;
  cavaRequest: CavaRequest;
};
export type PostApiCodeApiResponse =
  /** status 201 CREATED */ CodeCreatedResponse;
export type PostApiCodeApiArg = {
  manCodeRequest: ManCodeRequest;
};
export type GetApiCodeByIdApiResponse = /** status 200 OK */ ManCodeResponse;
export type GetApiCodeByIdApiArg = {
  /** Indicates whether to include the MANCode's journal in the response */
  includeJournal?: boolean;
  id: ManCodeId;
};
export type GetApiCodeByIdCheckApiResponse =
  /** status 200 OK */ CheckCodeResponse;
export type GetApiCodeByIdCheckApiArg = {
  /** Part period for which the check is to be conducted. If no part period is given, the MANCode's original part period will be used instead. */
  partPeriod?: Period;
  /** Specifies which final check outcome levels to accept. This parameter only takes effect if executeFinalChecks is set to true */
  checkAcceptanceLevel?: "Green" | "Yellow";
  /** Indicates whether to conduct final checks on the configuration */
  executeFinalChecks?: boolean;
  id: ManCodeId;
};
export type PutApiCodeByIdConfigurationApiResponse =
  /** status 201 CREATED */ ErrorResponse;
export type PutApiCodeByIdConfigurationApiArg = {
  system: QueryParameterSystem;
  id: ManCodeId;
  manCodeRequest: ManCodeRequest;
};
export type PostApiCodeByIdCopyApiResponse =
  /** status 201 CREATED */ ManCodeResponse;
export type PostApiCodeByIdCopyApiArg = {
  id: ManCodeId;
};
export type GetApiCodeByIdGetTokensAndSystemApiResponse =
  /** status 201 CREATED */ SystemListResponse;
export type GetApiCodeByIdGetTokensAndSystemApiArg = {
  system: QueryParameterSystem;
  id: ManCodeId;
};
export type PutApiCodeByIdResetTokensAndSystemApiResponse =
  /** status 201 CREATED */ StatusResponse;
export type PutApiCodeByIdResetTokensAndSystemApiArg = {
  system: QueryParameterSystem;
  id: ManCodeId;
};
export type PutApiCodeByIdSetTokensApiResponse =
  /** status 201 CREATED */ StatusResponse;
export type PutApiCodeByIdSetTokensApiArg = {
  id: ManCodeId;
  tokenRequest: TokenRequest;
};
export type PostApiConfigurationApiResponse =
  /** status 200 OK */ Configuration;
export type PostApiConfigurationApiArg = {
  ecmConfigurationTarget: EcmConfigurationTarget;
};
export type GetApiConfigurationByUuidApiResponse =
  /** status 200 OK */ ConfigurationStepData;
export type GetApiConfigurationByUuidApiArg = {
  groupForCompatibilityCheck?: ProductGroupId;
  uuid: EcmConfigId;
};
export type PutApiConfigurationByUuidChangeGroupOfInterestApiResponse =
  /** status 200 OK */ ConfigurationStepData;
export type PutApiConfigurationByUuidChangeGroupOfInterestApiArg = {
  groupForCompatibilityCheck: ProductGroupId;
  uuid: EcmConfigId;
};
export type GetApiConfigurationByUuidCheckBrakeRatioApiResponse =
  /** status 200 OK */ BrakeCheckResponse;
export type GetApiConfigurationByUuidCheckBrakeRatioApiArg = {
  uuid: EcmConfigId;
};
export type GetApiConfigurationByUuidCheckDvsApiResponse =
  /** status 200 OK */ DvsCheckResponse;
export type GetApiConfigurationByUuidCheckDvsApiArg = {
  uuid: EcmConfigId;
};
export type GetApiConfigurationByUuidCheckOasApiResponse =
  /** status 200 OK */ OasCheckResponse;
export type GetApiConfigurationByUuidCheckOasApiArg = {
  checkType: OasCheckType;
  uuid: EcmConfigId;
};
export type GetApiConfigurationByUuidCheckTiresApiResponse =
  /** status 200 OK */ TireCheckResponse;
export type GetApiConfigurationByUuidCheckTiresApiArg = {
  uuid: EcmConfigId;
};
export type GetApiConfigurationByUuidCheckWeightApiResponse =
  /** status 200 OK */ WeightCheckResponse;
export type GetApiConfigurationByUuidCheckWeightApiArg = {
  uuid: EcmConfigId;
};
export type PostApiConfigurationByUuidDeselectVariantsApiResponse =
  /** status 200 OK */ ConfigurationStepData;
export type PostApiConfigurationByUuidDeselectVariantsApiArg = {
  groupForCompatibilityCheck?: ProductGroupId;
  uuid: EcmConfigId;
  multiVariantDeselectionRequest: MultiVariantDeselectionRequest;
};
export type PutApiConfigurationByUuidRefreshApiResponse =
  /** status 200 OK */ RefreshConfigurationResponse;
export type PutApiConfigurationByUuidRefreshApiArg = {
  uuid: EcmConfigId;
};
export type PostApiConfigurationByUuidSelectVariantAndVariantIdApiResponse =
  /** status 200 OK */ ConfigurationStepData;
export type PostApiConfigurationByUuidSelectVariantAndVariantIdApiArg = {
  "variant-id": string;
  groupForCompatibilityCheck?: ProductGroupId;
  uuid: EcmConfigId;
  variantSelectionOptions: VariantSelectionOptions;
};
export type PostApiConfigurationByUuidSelectVariantsApiResponse =
  /** status 200 OK */ ConfigurationStepData;
export type PostApiConfigurationByUuidSelectVariantsApiArg = {
  groupForCompatibilityCheck?: ProductGroupId;
  uuid: EcmConfigId;
  multiVariantSelectionRequest: MultiVariantSelectionRequest;
};
export type PostApiConfigurationByUuidStepAndStepApiResponse =
  /** status 200 OK */ ConfigurationStepData;
export type PostApiConfigurationByUuidStepAndStepApiArg = {
  groupForCompatibilityCheck?: ProductGroupId;
  uuid: EcmConfigId;
  step: StepId;
  configurationStepDataOptions: ConfigurationStepDataOptions;
};
export type PutApiConfigurationByUuidSwitchBaseParametersApiResponse =
  /** status 200 OK */ SwitchBaseParametersResponse;
export type PutApiConfigurationByUuidSwitchBaseParametersApiArg = {
  uuid: EcmConfigId;
  switchBaseParametersRequest: SwitchBaseParametersRequest;
};
export type PostApiConfigurationByUuidUndocommitApiResponse =
  /** status 200 OK */ ConfigurationStepData;
export type PostApiConfigurationByUuidUndocommitApiArg = {
  uuid: EcmConfigId;
  configurationStepDataOptions: ConfigurationStepDataOptions;
};
export type PostApiConfigurationValidateApiResponse =
  /** status 200 OK */ ValidationResponse;
export type PostApiConfigurationValidateApiArg = {
  validationResponse: ValidationResponse;
};
export type PostApiConvertEcmConfigByUuidApiResponse =
  /** status 201 CREATED */ ConvertEcmConfigResponse;
export type PostApiConvertEcmConfigByUuidApiArg = {
  uuid: EcmConfigId;
  ecmConversionTarget: EcmConversionTarget;
};
export type PostApiConvertMancodeApiResponse =
  /** status 201 CREATED */ ManCodeConversionResponse;
export type PostApiConvertMancodeApiArg = {
  manConversionTarget: ManConversionTarget;
};
export type GetApiConvertMancodeIdByUuidConvertToGdcInputApiResponse =
  /** status 200 OK */ ManCodeIdToGdcConversionResponse;
export type GetApiConvertMancodeIdByUuidConvertToGdcInputApiArg = {
  uuid: ManCodeId;
};
export type PostApiConvertTg3CodeByLanguageApiResponse =
  /** status 200 OK */ Tg3ToMaicConversionResponse;
export type PostApiConvertTg3CodeByLanguageApiArg = {
  /** Indicates if empty component groups will be returned */
  addEmptyGroups?: boolean;
  /** Indicates if empty families will be returned */
  addEmptyFamilies?: boolean;
  /** Indicates if hidden codes that are excluded from the response */
  excludeHiddenCodes?: boolean;
  /** Indicates if codes that are ineffective for sales are excluded from the response */
  excludeIneffectiveCodes?: boolean;
  /** V-code indicating the vehicle's application segment (e.g. waste disposal, long-distance traffic, or street cleaning). Code is used to improve the conversion result. */
  applicationSegment?: string;
  /** Indicates if mapping from V-codes to FPC-codes should be computed and returned */
  addFpcMapping?: boolean;
  /** Denotes the target language that will be used for textual configuration descriptions */
  language: LanguageIsoCode;
  /** Identifies the ECM view which the C4S assembly hierarchy is mapped to */
  viewId?: ViewId;
  tg3ConversionRequest: Tg3ConversionRequest;
};
export type GetApiProductdataGetconfigurationtypeidsApiResponse =
  /** status 200 OK */ ConfigTypeInfo;
export type GetApiProductdataGetconfigurationtypeidsApiArg = void;
export type GetApiProductdataGetvehicletypeidsApiResponse =
  /** status 200 OK */ VehicleTypeInfo;
export type GetApiProductdataGetvehicletypeidsApiArg = void;
export type GetApiProductdataGetviewheadersByMarketIdApiResponse =
  /** status 200 OK */ ViewHeaderInfo;
export type GetApiProductdataGetviewheadersByMarketIdApiArg = {
  marketId: MarketId;
};
export type GetApiProductdataImportantFamiliesFactoryApiResponse =
  /** status 200 OK */ ImportantFamiliesFactoryResponse;
export type GetApiProductdataImportantFamiliesFactoryApiArg = void;
export type GetApiProductdataMarketByMarketIdLanguageAndLanguageIdFamiliesApiResponse =
  /** status 200 OK */ AllFamiliesResponse;
export type GetApiProductdataMarketByMarketIdLanguageAndLanguageIdFamiliesApiArg =
  {
    languageId: LanguageId;
    includeOnlyLocalCodes?: boolean;
    marketId: MarketId;
    viewId?: ViewId;
  };
export type GetApiProductdataMarketByMarketIdLanguagesApiResponse =
  /** status 200 OK */ MarketLanguages;
export type GetApiProductdataMarketByMarketIdLanguagesApiArg = {
  marketId: MarketId;
};
export type GetApiProductdataMarketByMarketIdPartPeriodFromDesiredDealerDateApiResponse =
  /** status 200 OK */ DddToPpResponse;
export type GetApiProductdataMarketByMarketIdPartPeriodFromDesiredDealerDateApiArg =
  {
    vehicleTypeId: VehicleTypeId;
    marketId: MarketId;
    desiredDealerDate: DesiredDealerDate;
  };
export type GetApiTg3CodeByIdApiResponse =
  /** status 200 OK */ LegacyManCodeResponse;
export type GetApiTg3CodeByIdApiArg = {
  id: string;
};
export type GetApiUserdataGetmarketsApiResponse =
  /** status 200 OK */ MarketInfo;
export type GetApiUserdataGetmarketsApiArg = void;
export type GetApiUserdataLoadApiResponse = /** status 200 OK */ UserData;
export type GetApiUserdataLoadApiArg = void;
export type PostApiUserdataUpdateApiResponse = unknown;
export type PostApiUserdataUpdateApiArg = {
  userData: UserData;
};
export type GetApiVisualizationFetchMediumByFetchCodeApiResponse =
  /** status 200 OK */
    | VisImageReady
    | /** status 202 202 response */ VisImagePending;
export type GetApiVisualizationFetchMediumByFetchCodeApiArg = {
  /** A fetch code provided by a previous order_medium call (if the image was not already cached) */
  fetchCode: VisFetchCode;
};
export type PostApiVisualizationOrderMediumApiResponse = /** status 200 OK */
  | VisImageReady
  | /** status 202 202 response */ VisImagePending;
export type PostApiVisualizationOrderMediumApiArg = {
  visOrderRequest: VisOrderRequest;
};
export type GetTokenManagementApiResponse = unknown;
export type GetTokenManagementApiArg = void;
export type PostUnittestingApiResponse = /** status 200 OK */ Blob;
export type PostUnittestingApiArg = void;
export type StatusResponse = {
  /** Integer indicating a certain outcome state */
  status: number;
  /** Textual description of outcome state */
  title: string;
};
export type LocalizedString = {
  [key: string]: string;
};
export type AdminNatCodesItemDescription = {
  description?: LocalizedString & object;
  label?: LocalizedString & object;
  /** A value hinting at the rank this object should take in an array of objects of the same type. */
  priorityForSorting?: number;
};
export type ConfigTypeId = number;
export type CountryIsoCode = string;
export type Currency = string;
export type NatCodeCurrency = Currency;
export type LanguageIsoCode = string;
export type LanguageId = number;
export type AdminToolMarketLanguage = {
  languageCode: LanguageIsoCode;
  languageId: LanguageId;
  languageLabel: LocalizedString;
};
export type MarketId = number;
export type Period = string;
export type VehicleTypeId = number;
export type ViewId = number;
export type AdminNatCodesMarketDescription = AdminNatCodesItemDescription & {
  configTypeId?: ConfigTypeId;
  countryCode?: CountryIsoCode & any;
  currency?: NatCodeCurrency;
  description?: LocalizedString & object;
  languages?: AdminToolMarketLanguage[];
  marketId?: MarketId;
  /** A list of tags hinting at the target audience for this market */
  plannedUsage?: string[];
  validPartPeriodEnd?: Period;
  validPartPeriodStart?: Period;
  vehicleTypeId?: VehicleTypeId;
  viewId?: ViewId;
};
export type AdminNatCodesGroupId = string;
export type AdminNatCodesGroupDescription = AdminNatCodesItemDescription & {
  /** Name of corresponding group in ECM vehicle schema */
  ecmReference?: string;
  groupId?: AdminNatCodesGroupId;
};
export type AdminNatCodesFamilyId = string;
export type AdminNatCodesFamilyDescription = AdminNatCodesItemDescription & {
  familyId?: AdminNatCodesFamilyId;
};
export type NatCodeClassification = "A" | "T" | "S";
export type NatCodeCommissionRelevant = boolean;
export type NatCodeCondition =
  | "C"
  | "E"
  | "G"
  | "I"
  | "K"
  | "L"
  | "N"
  | "O"
  | "S"
  | "U"
  | "V"
  | "W"
  | "Z";
export type CodeGrossListPrice = number;
export type CodeHideCode = boolean;
export type NatCodeOrderRelevant = boolean;
export type PictureIndex = number[];
export type PrintingOptions = (
  | "picture"
  | "boldCode"
  | "extendedDescription"
  | "hidden"
)[];
export type CodePrintingOptions = PrintingOptions;
export type CodeRelevantForMaintenanceAndRepairBenefits = boolean;
export type CodeRelevantForResidualValue = boolean;
export type CodeTopOption = boolean;
export type CodeWithoutCode = boolean;
export type AdminNatCodesExecutionId = string;
export type AdminNatCodesBooleanRule = string;
export type AdminNatCodesCodeBaseBaseDescription =
  AdminNatCodesItemDescription & {
    attributes?: {
      classification?: NatCodeClassification;
      commissionRelevant?: NatCodeCommissionRelevant;
      condition?: NatCodeCondition;
      grossListPrice?: CodeGrossListPrice;
      hideCode?: CodeHideCode;
      orderRelevant?: NatCodeOrderRelevant;
      pictureIndex?: PictureIndex;
      printingOptions?: CodePrintingOptions;
      relevantForMaintenanceAndRepairBenefits?: CodeRelevantForMaintenanceAndRepairBenefits;
      relevantForResidualValue?: CodeRelevantForResidualValue;
      topOption?: CodeTopOption;
      withoutCode?: CodeWithoutCode;
    };
    executionId?: AdminNatCodesExecutionId;
    /** Set of Boolean rules used to decide whether this code can be added to an existing vehicle configuration */
    rules?: AdminNatCodesBooleanRule[];
    validFrom?: Period & any;
    validTo?: Period & any;
  };
export type AdminNatCodesCodeId = string;
export type AdminNatCodesCodeBaseDescription =
  AdminNatCodesCodeBaseBaseDescription & {
    codeId?: AdminNatCodesCodeId;
  };
export type AdminNatCodesCodeStatus =
  | "draft"
  | "published"
  | "draft_formerly_published";
export type AdminNatCodesCodeDescription = AdminNatCodesCodeBaseDescription & {
  status?: AdminNatCodesCodeStatus;
};
export type AdminNatCodesCode = AdminNatCodesCodeDescription & object;
export type AdminNatCodesFamily = AdminNatCodesFamilyDescription & {
  codes?: AdminNatCodesCode[];
};
export type AdminNatCodesGroup = AdminNatCodesGroupDescription & {
  families?: AdminNatCodesFamily[];
};
export type AdminNatCodesMarket = AdminNatCodesMarketDescription & {
  groups?: AdminNatCodesGroup[];
};
export type AdminAllMarketsResponse = StatusResponse & {
  /** List of all available markets in national codes admin tool */
  markets?: (AdminNatCodesMarketDescription | AdminNatCodesMarket)[];
  warnings?: string[];
};
export type ErrorResponse = StatusResponse & {
  error?: {
    /** Descriptive error message */
    description?: string;
    /** Further details about the error */
    metadata?: {
      [key: string]: any;
    };
    /** Integer indicating a certain outcome state */
    status?: number;
    /** Textual description of outcome state */
    title?: string;
    /** Technical error type / code */
    type?: string;
  };
};
export type AdminMarketDescriptionResponse = StatusResponse & {
  market?: AdminNatCodesMarket;
};
export type AdminNatCodesNewMarketRequest = AdminNatCodesMarketDescription &
  object;
export type Attributes = {
  [key: string]: any;
};
export type ProductFamilyId = string;
export type FlattenedFpcCode = string;
export type FactoryCodeItemId = ProductFamilyId | FlattenedFpcCode;
export type ZonedDateTime = string;
export type FactoryCodeAttributes = {
  attributes: Attributes;
  code: FactoryCodeItemId;
  createdAt: ZonedDateTime;
  updatedAt: ZonedDateTime;
};
export type AdminAllFactoryCodeAttributesResponse = StatusResponse & {
  listOfFactoryCodeAttributes?: FactoryCodeAttributes[];
};
export type AdminFactoryCodeAttributesResponse = StatusResponse & {
  factoryCodeAttributes?: FactoryCodeAttributes;
};
export type FactoryCodeAttributeRequest = {
  attributes?: Attributes;
};
export type AdminNatCodesGroupDescriptionResponse = StatusResponse & {
  group?: AdminNatCodesGroup;
};
export type AdminNatCodesNewGroupRequest = AdminNatCodesGroupDescription & {
  groupId: AdminNatCodesGroupId;
};
export type AdminNatCodesFamilyDescriptionResponse = StatusResponse & {
  family?: AdminNatCodesFamily;
};
export type AdminNatCodesNewFamilyRequest = AdminNatCodesFamilyDescription & {
  familyId: AdminNatCodesFamilyId;
};
export type AdminNatCodesCodeDescriptionResponse = StatusResponse & {
  code?: AdminNatCodesCode;
};
export type AdminNatCodesNewCodeRequest =
  AdminNatCodesCodeBaseBaseDescription & {
    executionId: AdminNatCodesExecutionId;
  };
export type ImportantFamilies = ProductFamilyId[];
export type ImportantFamiliesCountryResponse = StatusResponse & {
  importantFamilies: ImportantFamilies;
};
export type ImportantFamiliesCountryRequest = {
  importantFamilies: ImportantFamilies;
};
export type SelectionType = "User" | "Default" | "Explicit" | "Implicit";
export type ProductVariantId = string;
export type FpcCommonCode = {
  /** Concatenates family and execution */
  code?: string;
  family: ProductFamilyId;
  /** Textual description of the variant's family */
  familyDescription?: string;
  grossListPrice?: CodeGrossListPrice;
  hideCode?: CodeHideCode;
  pictureIndex?: PictureIndex;
  printingOptions?: CodePrintingOptions;
  relevantForMaintenanceAndRepairBenefits?: CodeRelevantForMaintenanceAndRepairBenefits;
  relevantForResidualValue?: CodeRelevantForResidualValue;
  selectionType?: SelectionType;
  topOption?: CodeTopOption;
  variant: ProductVariantId;
  /** Textual description of the variant */
  variantDescription?: string;
  withoutCode?: CodeWithoutCode;
};
export type SpecificationType = "O" | "C" | "V";
export type FpcFactoryCode = FpcCommonCode & {
  /** Controls the display of FPC codes in the frontend. If the attribute is set to true, the FPC Code will not be displayed in the FE. Source: Product Data from XDMA. */
  ineffectiveForSales?: boolean;
  /** Controls the display of prices in the frontend. If the attribute is set to true, the grossListPrice of the FPC code will not be displayed in the FE. Source: Product Data from XDMA. */
  noDisplayOfAbsolutePrice?: boolean;
  /** The code's specification type(s). Source: ECM */
  specTypes?: SpecificationType[];
};
export type ManCodeId = string;
export type MarketDenomination = string;
export type PublicationStatus = "draft" | "published" | "archived";
export type ReferenceTruckId = string;
export type ReferenceTruck = {
  application?: FpcFactoryCode;
  axleDistance?: FpcFactoryCode;
  cabType?: FpcFactoryCode;
  createdAt: ZonedDateTime;
  customText?: LocalizedString;
  customTitle?: LocalizedString;
  MANCodeId: ManCodeId;
  marketDenomination?: MarketDenomination;
  operation?: FpcFactoryCode;
  previewImageURL?: string;
  publicationStatus?: PublicationStatus;
  referenceTruckId: ReferenceTruckId;
  updatedAt: ZonedDateTime;
  usages?: FpcFactoryCode;
  weight?: string;
};
export type AdminAllReferenceTrucksResponse = StatusResponse & {
  listOfReferenceTrucks?: ReferenceTruck[];
};
export type AdminReferenceTrucksResponse = StatusResponse & {
  referenceTruck?: ReferenceTruck;
};
export type UpdateReferenceTruckRequest = {
  customText?: LocalizedString & any;
  customTitle?: LocalizedString & any;
  MANCodeId?: ManCodeId;
  publicationStatus?: PublicationStatus;
};
export type NewReferenceTruckRequest = UpdateReferenceTruckRequest & {
  publicationStatus?: PublicationStatus & any;
};
export type ResponseEnvelopeMessage = {
  content?: string;
  key?: string;
  messageType?: "Information" | "Error" | "Debug";
  referenceIndex?: number;
};
export type ResponseEnvelope = {
  /** Specific Response containing either vehicle-dimensions, dp, dvs or n3g information. */
  content?: object;
  hasErrors: boolean;
  messages: ResponseEnvelopeMessage[];
  success: boolean;
};
export type DvsResponse = ResponseEnvelope & {
  content?: {
    remainingHeightToNextStarRating?: string;
    starRating?: string;
  };
};
export type GroundClearanceContract = {
  limit: number;
  limitedBy: string;
  ok: boolean;
  value: number;
};
export type VehicleContract = {
  approachAngle: GroundClearanceContract;
  awd: boolean;
  breakOverAngle: GroundClearanceContract;
  climbAngle: GroundClearanceContract;
  departureAngle: GroundClearanceContract;
  differentialLock: boolean;
  enoughNumberOfWheelsDriven: boolean;
  groundClearanceAndRampAngelsOk: boolean;
  groundClearanceBetweenAxles: GroundClearanceContract;
  groundClearanceUnderFrontAxle: GroundClearanceContract;
  groundClearanceUnderRearAxle: GroundClearanceContract;
};
export type N3GResponse = ResponseEnvelope & {
  content?: {
    compliesToN3G: boolean;
    vehicle: VehicleContract;
    versionNumberRDW: number;
  };
};
export type TurningRadiusResponse = ResponseEnvelope & {
  content?: {
    /** The inner radius [m] - radius yielded by the inner wheel when turning */
    innerRadius?: number;
    /** The outer radius [m] - radius yielded by the outer wheel when turning */
    kerbRadius?: number;
    /** The load center [m] (Turning radius style) of the rear axle group */
    rearAxleGroupLoadCenter?: number;
    /** How much the rear edge of the vehicle swings out compared to the rear wheel [m] */
    rearSwingout?: number;
    /** The wall radius [m] - radius yielded by other components at the front of the vehicle */
    wallRadius?: number;
  };
};
export type Cab = {
  /** Distance between the centre of the first front axle and the rear end of the cab [m] */
  endOfCab?: number;
  /** Distance from top of frame to top of cab roof [m] */
  heightAboveFrame?: number;
  overallWidth?: number;
  /** Width of cab [m] */
  width?: number;
};
export type FifthWheel = {
  /** Radius from cab rear wall (max allowed) to kingpin fifth wheel [m] */
  frontSlewRadius?: number;
  /** Height of fifth-wheel coupling above sub-frame, uppermost position [m] */
  height: number;
  /** Distance from top edge of fifth-wheel coupling, in uppermost position, to ground in laden condition [m] */
  heightFromGroundLaden?: number;
  /** [m] */
  kingpinPositionRelativeFirstDrivenRearAxle?: number;
  /** Distance from centre of the first front axle of vehicle to centre of fifth-wheel kingpin coupling [m] */
  kingpinPositionRelativeFrontAxle?: number;
  /** Distance from the connection point on the fifth wheel to the rear corner of the vehichle assuming it is a perfect rectangle [m] */
  maximumDistanceKingpinToRearCorner?: number;
  /** Height of fifth-wheel sub-frame measured from top edge of frame to top edge of sub-frame [m] */
  mountingPlateHeight?: number;
  type: "Fixed" | "Sliding";
};
export type Axle = {
  /** Distance from the axle centerline to the axle in front of it [m] */
  distanceToPrecedingAxle?: number;
  /** External width across the wheels on the n-th axle [m] (BEP-W003) */
  externalWidth?: number;
  /** Relative position of the axle within its axle group [m] */
  position?: number;
  /** Static loaded radius of the tyres */
  staticLoadedRadius?: number;
  /** Maximum weight that may be placed on the axle [kg] */
  technicalWeight?: number;
};
export type AxleGroup = {
  axles: Axle[];
  /** Distance between first front axle / first driven rear axle to calculated mass line of front / rear axle combination [kg] */
  loadCenter?: number;
  suspension?: {
    airSuspensionHeight?: {
      /** Height change between driving position and lowest lowered position */
      loweringFromDrivingPos?: number;
      /** Height change between driving position and topmost raised position */
      raisingFromDrivingPos?: number;
    };
    type?: "Leaf" | "Air";
  };
  /** Chassis weight without payload distributed onto the front/rear axle group [kg] */
  unladenWeight?: number;
};
export type ChassisHeights = {
  /** Distance from top edge of frame to ground measured at the first front axle [m] */
  heightOfFrameFront?: number;
  /** Distance from top edge of frame to ground measured at the theoretical wheelbase [m] */
  heightOfFrameTheoreticalWheelBaseRear?: number;
  suspensionHeightFromTopOfFrameFront?: number;
  suspensionHeightFromTopOfFrameTheoreticalWheelBaseRear?: number;
};
export type HeightData = {
  chassisHeights: ChassisHeights;
  /** Distance from ground to top of cab, including cab mounted parts [m] */
  maximumExternalHeightInHighestMode?: number;
  /** Distance from ground to top of cab, including cab mounted parts [m] */
  maximumExternalHeightInLowestMode?: number;
};
export type RearFrameOverhang = {
  /** Distance between the centre of first driven rear axle to rearmost edge of frame side member [m] */
  fromFirstDrivenRearAxle?: number;
  /** Distance between the centre of last axle to rearmost edge of frame side member [m] */
  fromLastAxle?: number;
};
export type TrailerCouplingPosition = {
  componentReference:
    | "ComponentFront"
    | "ComponentInner"
    | "ComponentCenter"
    | "ComponentTop"
    | "ComponentBottom";
  /** [m] */
  value: number;
  vehicleReference:
    | "FrameEnd"
    | "TopOfFrame"
    | "FirstFrontAxle"
    | "ParentCenter"
    | "FrameOuter";
};
export type TrailerCoupling = {
  /** Vertical distance from top of frame to pin centerline. See PD 2975234 for details (BEP-H045) [m] */
  heghtTopOfFrameToPinCentre?: number;
  /** Vertical distance between the bottom of the trailer coupling and the pin centerline. See PD 2975234 for details [m] With AMIGA this is the total height of the coupling. */
  height?: number;
  /** Distance between the trailer coupling pin center and the face of the inner region of the draw beam. See PD 2975234 for details [m] NOT VALID WIH AMIGA */
  jc?: number;
  /** Distance between the trailer coupling front and the face of the inner region of the draw beam. See PD 2975234 for details [m] With AMIGA this is the total length of the coupling */
  length?: number;
  /** Distance from first front axle to pin centerline (BEP-L045) [m] */
  lengthFirstFrontAxlePinCentre?: number;
  x: TrailerCouplingPosition;
};
export type TruckResults = {
  /** Distance between centre of first front axle to the centre of first driven rear axle [m] */
  axleDistance?: number;
  cab?: Cab;
  fifthWheel?: FifthWheel;
  /** Profile height of frame section p [m] */
  frameHeight?: number;
  /** Frame, side member flange width. FPC2431 [m] */
  frameSideMemberWidth?: number;
  /** Overall thickness of all the steel used in the frame [m] */
  frameThickness?: number;
  frontAxleGroup?: AxleGroup;
  /** Distance between front edge of vehicle and centre of wheel on first axle [m] */
  frontVehicleOverhang?: number;
  /** Distance from top of frame to top of cab, including cab mounted parts, with the chassis unladen but in operating order [m] */
  heightAboveFrameInHighestMode?: number;
  /** Distance from top of frame to top of cab, including cab mounted parts, with the chassis unladen but in operating order [m] */
  heightAboveFrameInLowestMode?: number;
  heightLaden?: HeightData;
  heightUnladen?: HeightData;
  /** Frame length behind cab [m] */
  lengthOfFrameBehindCab?: number;
  maxSteeringAngleLeft?: number;
  maxSteeringAngleRight?: number;
  /** Max width of chassis [m] */
  maxWidth?: number;
  /** [m] */
  minimumAllowedDistanceFirstFrontAxleToBodywork?: number;
  /** Distance from front edge of vehicle to rear edge of vehicle, including accessories in both front and rear ends [m] */
  overallLength?: number;
  rearAxleGroup?: AxleGroup;
  rearFrameOverhang?: RearFrameOverhang;
  /** External width of frame in rear area of the vehicle [m] */
  rearFrameWidth?: number;
  /** Distance between the calculated mass lines of front and rear axle combinations [m] */
  theoreticalWheelBase?: number;
  trailerCoupling?: TrailerCoupling;
};
export type VehicleDimensionsResponse = ResponseEnvelope & {
  content?: {
    vehicleResult?: TruckResults;
  };
};
export type CavaResponse = StatusResponse & {
  content?: {
    /** Contains Direct Vision Standard information - can currently be anything */
    dvs?: DvsResponse;
    /** Contains information specific to the N3G vehicle category - can currently be anything */
    n3g?: N3GResponse;
    turningRadius?: TurningRadiusResponse;
    /** Contains information about vehicle dimensions - can currently be anything */
    vehicleDimension?: VehicleDimensionsResponse;
  };
};
export type CavaRequest = {
  /** Indicates whether to include information about vehicle dimensions in the response */
  includeDimensions?: boolean;
  /** Indicates whether to include Direct Vision Standard information */
  includeDvs?: boolean;
  /** Indicates whether to include information specific to the N3G vehicle category */
  includeN3g?: boolean;
  /** Indicates whether to include information about the vehicle's turning abilities */
  includeTurningRadii?: boolean;
  /** Additional information for computing turning radii data */
  turnData?: {
    /** Indicates the turning direction */
    turnDirection?: "Left" | "Right";
  };
};
export type VariantList = {
  familyId: ProductFamilyId;
  variantId: ProductVariantId;
}[];
export type CavaProvisionedRequest = CavaRequest & {
  variants: VariantList;
};
export type EcmConfigId = string;
export type CodeCreatedResponse = StatusResponse & {
  feedback?: {
    code?: ManCodeId;
  };
};
export type ProductFamilyTitle = string;
export type OptionFamily = {
  familyId: ProductFamilyId;
  title: ProductFamilyTitle;
};
export type OptionVariantItem = {
  price: number;
  title: string;
  variantId: ProductVariantId;
};
export type OptionVariant = {
  family: OptionFamily;
  pictureIndex?: PictureIndex;
  printingOptions?: PrintingOptions;
  sourceVariant: OptionVariantItem;
  targetVariant: OptionVariantItem;
  version: number;
};
export type AdditionalOption = {
  implicitChanges?: OptionVariant[];
  /** An option specific identifier */
  optionId: string;
  status: "checked" | "unchecked" | "removed";
  /** An option specific title */
  title?: string;
  variants?: OptionVariant[];
};
export type DesiredDealerDate = string;
export type EcmModelId = number;
export type EcmParameters = {
  configurationTypeId: ConfigTypeId;
  languageId?: LanguageId;
  marketId: MarketId;
  vehicleTypeId: VehicleTypeId;
  viewId: ViewId;
};
export type KeyValuePair = {
  key?: string;
  value?: string;
};
export type KeyValuePairList = KeyValuePair[];
export type MaicInternal = {
  keyValuePairs?: KeyValuePairList;
};
export type FpcNationalCode = FpcCommonCode & {
  classification?: NatCodeClassification;
  /** Concatenates family and execution */
  code?: string;
  commissionRelevant?: NatCodeCommissionRelevant;
  condition?: NatCodeCondition;
  currency?: NatCodeCurrency;
  /** The variant's family */
  family?: string;
  /** Textual description of the national code */
  name?: string;
  orderRelevant?: NatCodeOrderRelevant;
};
export type OrderCountry = CountryIsoCode;
export type SpecialRequest = boolean;
export type VehicleDescription = string;
export type VehicleConfiguration = {
  /** List of selected addtional options alias offers. */
  additionalOptions?: AdditionalOption[];
  /** Represents an ID for verifying a new central data status after the publication of this data in EBO. Source: tba. */
  centralDataVersion?: number;
  /** Represents the requested delivery date, which was passed on as a call parameter by the source systems. This value might represent an estimate. Source: MAIC Frontend (if set by user) or Backend (). */
  desiredDealerDate?: DesiredDealerDate;
  /** Indicates if the desired dealer date was estimated from a part period or refers to a concrete date that was set by the user. Source: MAIC Backend */
  desiredDealerDateIsEstimate?: boolean;
  ecmModelId?: EcmModelId;
  ecmParameters?: EcmParameters;
  /** A list of all selected FPC codes from the factory set. Source: ECM */
  factoryFPCCodes?: FpcFactoryCode[];
  /** Represents the sum of all individual priced FPC codes and thus the gross list price of the vehicle. Source: MAIC Frontend/Backend. */
  grossListPrice?: number;
  MAICInternal?: MaicInternal;
  /** Represents an ID for verifying a new national data status after the publication of this data in EBO. Source: MAIC Admintool. */
  nationalDataVersion?: number;
  /** A list of all selected FPC from the national or business unit set. Source: MAIC Admintool */
  nationalFPCCodes?: FpcNationalCode[];
  orderCountry?: OrderCountry;
  orderLanguage?: LanguageIsoCode;
  /** List of FPC families that are part of the configuration's C-spec but do not belong to the O-spec. This list is internally used to guarantee faithful restoration of MANCode configurations in ECM as this requires an O-spec instead of the stored C-spec. */
  oSpecCSpecDelta?: ProductFamilyId[];
  /** Represents the status of the configuration or quotation or purchase order, depending on the process step in which the configuration is located. Source: ITOS */
  overallStatus?: "quote" | "order" | "orderChange" | "processedLUR";
  partPeriod?: Period;
  specialRequest?: SpecialRequest;
  validationPartPeriod?: Period;
  vehicleDescription?: VehicleDescription;
};
export type UpdatePatchLocation = string;
export type UpdatePatchPath = UpdatePatchLocation & string;
export type UpdatePatchValue = FpcFactoryCode & object;
export type UpdatePatchAdd = {
  op?: string;
  path?: UpdatePatchPath;
  value?: UpdatePatchValue & any;
};
export type UpdatePatchFrom = UpdatePatchLocation & string;
export type UpdatePatchCopy = {
  from?: UpdatePatchFrom;
  op?: string;
  path?: UpdatePatchPath;
};
export type UpdatePatchMove = {
  from?: UpdatePatchFrom;
  op?: string;
  path?: UpdatePatchPath;
};
export type UpdatePatchRemove = {
  op?: string;
  path?: UpdatePatchPath;
};
export type UpdatePatchReplace = {
  op?: string;
  path?: UpdatePatchPath;
  value?: UpdatePatchValue & any;
};
export type UpdatePatchTest = {
  op?: string;
  path?: UpdatePatchPath;
  value?: UpdatePatchValue & any;
};
export type UpdatePatch =
  | UpdatePatchAdd
  | UpdatePatchCopy
  | UpdatePatchMove
  | UpdatePatchRemove
  | UpdatePatchReplace
  | UpdatePatchTest;
export type ManCodeJournalEntry = {
  /** Describes the update operations that would need to be conducted to arrive at a the previous version of this MANCode */
  backwardUpdateOperations?: UpdatePatch[];
  /** Indicates the place that this update takes in a series of updates */
  entryNumber?: number;
  /** Describes the update operations that were conducted to arrive at this version of the MANCode */
  forwardUpdateOperations?: UpdatePatch[];
  updateTimestamp?: ZonedDateTime & string;
  /** Indicates which calling system performed the update */
  updatingSystem?: string;
  /** Indicates which calling user performed the update */
  updatingUser?: string;
};
export type ManCodeJournal = {
  /** Indicates which patch of the journal is currently active */
  currentPatch?: number;
  /** Individual updates of a MANCode */
  entries?: ManCodeJournalEntry[];
};
export type ManCodeObjectVersion = string;
export type QueryParameterSystem = string;
export type SystemToken = {
  system?: QueryParameterSystem;
};
export type SystemTokens = SystemToken[];
export type ManCode = {
  code?: ManCodeId;
  configuration?: VehicleConfiguration;
  /** ID of the system that created this MANCode. Note that in responses, this information will only be displayed for consumers with appropriate access rights */
  createdBySystem?: string;
  /** ID of the user that created this MANCode. Note that in responses, this information will only be displayed for consumers with appropriate access rights */
  createdByUser?: string;
  insertTimestamp?: ZonedDateTime;
  journal?: ManCodeJournal;
  manCodeObjectVersion?: ManCodeObjectVersion;
  manCodeReference?: ManCodeId;
  /** MANCode is lightweight version */
  reducedVersion?: boolean;
  tokens?: SystemTokens;
  updateTimestamp?: ZonedDateTime;
};
export type ManCodeRequest = {
  /** Indicates whether header data should also be copied */
  directCopy?: boolean;
  MANCode: ManCode;
};
export type ManCodeResponse = StatusResponse & {
  code: ManCode;
};
export type CheckCodeResponse = StatusResponse & {
  /** Indicates if the MANCode is valid or not */
  outcome?: "valid" | "invalid";
  /** Textual description of outcome details, e.g. an explanation why a code is no longer valid */
  outcomeDetails?: string;
};
export type SystemListResponse = {
  /** List of systems for which tokens are set */
  systems?: string[];
};
export type TokenRequest = {
  /** List of systems for which tokens are to be set */
  systems?: string[];
};
export type Configuration = StatusResponse & {
  uuid: EcmConfigId;
};
export type VariantIsSelected = boolean;
export type VariantSelectionType = "Default" | "Explicit" | "Implicit";
export type EcmConfigurationTarget = {
  /** Specifies the target configuration type. If the there are no configuration types associated with your target market, do not include this property in the request body. However, if there are configuration type ids available for the market, you must select one, otherwise the request will fail */
  configurationTypeID?: ConfigTypeId;
  /** Specifies the target ?construction? period. Use either this or desiredDealerDate. If both are used, confiremdPartPeriod is ignored. */
  confirmedPartPeriod?: Period;
  /** Specifies the target ?construction? day. Use either this or confirmedPartPeriod. If both are used, confiremdPartPeriod is ignored. */
  desiredDealerDate?: DesiredDealerDate;
  ecmModelId?: EcmModelId;
  languageID?: LanguageId;
  /** Specifies the target market */
  marketID: MarketId;
  /** List of variants with which to start the configuration */
  startingVariants?: {
    familyId?: ProductFamilyId;
    isSelected?: VariantIsSelected;
    selectionType?: VariantSelectionType;
    variantId?: ProductVariantId;
  }[];
  /** Specifies the target vehicle type. Though you should use the correct one, it somehow does not seem to matter too much which ID is used as long as it is not too large. 11 seems to always work nicely... */
  vehicleTypeID: VehicleTypeId;
  /** Specifies the target view */
  viewID: ViewId;
};
export type ProductVariant = {
  /** Hints at the compatibility of this variant with the current vehicle. 'incompatible' means that the selection would result in a conflict with at least one of the user-selected variant. 'unknown' means that no definite statement about the variant's compatibility can be made. 'invalid' is a relic stemming from an earlier ECM iteration and should be treated the same as 'compatibilityUnknown', however, it should hopefully never occur */
  compatibility?: "unknown" | "incompatible" | "invalid";
  /** Automatically generated dummy price, not to be confused with actual real-world prices. It is deterministic and depends on the variant's family's id and on the variant's id. Note that currently each variant is assigned a dummy price although that does not make sense for e.g. some of the variants used in the General Step. */
  dummy_price?: number;
  hasDetailData?: boolean;
  id: ProductVariantId;
  isSelected?: VariantIsSelected;
  selectionType?: VariantSelectionType;
  /** Textual description of the variant, depends on selected language */
  title: string;
};
export type VariantConsequences = {
  /** The new variant. Note that this property is only contained if the previous variant was replaced or if a completely new variant was added, but not if the old variant was removed. */
  currentVariant?: ProductVariant;
  /** Variant in the previous configuration. Note that this property is only contained if the old variant was replaced or removed, but not if an entirely new variant was added. */
  previousVariant?: ProductVariant;
  /** Information about the family of the variant that was changed */
  productFamily?: {
    id?: ProductFamilyId;
    title?: ProductFamilyTitle;
  };
  /** Indicates whether the old variant was changed, removed, or a new variant was added */
  variantStatus?: "Added" | "Changed" | "Removed";
}[];
export type ConsequencesOfChange = {
  /** Added, changed, or removed variants that were part of the previous configuration   and were selected explicitely by the user */
  variantConflictingChoices?: VariantConsequences;
  /** Added, changed, or removed variants that were part of the previous configuration   but that were not selected explicitely by the user. */
  variantConsequences?: VariantConsequences;
};
export type ProductFamily = {
  committed?: boolean;
  hasDetailData?: boolean;
  id: ProductFamilyId;
  selectedVariantIndex?: number;
  title: ProductFamilyTitle;
  totalVariantCount: number;
  variants: ProductVariant[];
};
export type ProductGroupId = string;
export type ProductGroup = {
  families?: ProductFamily[];
  id: ProductGroupId;
  subGroups?: ProductGroup[];
  title: string;
};
export type ConfigurationStepData = StatusResponse & {
  /** Describes consequences resulting from one ore more changed variants. Note that if you are dealing with the result of an undo-operation, this property will contain the result from before the reverted variant selection. */
  consequencesOfChange?: ConsequencesOfChange;
  currentStep?: string;
  marketDenomination?: MarketDenomination;
  /** Technical data points of the current configuration. Note that unfortunately the ECM documentation does not provide any explanations for the particular properties, our descriptions are therefore more or less guesswork */
  measurements?: {
    /** Textual description of the measurement */
    description?: string;
    /** The measurement's ID */
    name?: string;
    /** Not clear */
    source?: "OAS" | "Configurator";
    /** Denotes the unit in which the acutal measure was taken. Note that this property seems to be missing often */
    unit?: string;
    value?: string;
  }[];
  /** Describes which variants do not fit the producers technical recommendations properly */
  outOfRecommendationWarnings?: {
    familyId?: ProductFamilyId;
    /** Further textual explanation of the warning */
    notes?: string;
    /** Classification of the warning's type */
    outOfRecommendationHint?: "OutOfRecommendation" | "Hint";
    variantId?: ProductVariantId;
  }[];
  productGroups: ProductGroup[];
  /** Contains information about required changes to the configuration to make the vehicle buildable again. This field should only contain information if autoApplyConflictingChanges was set to False. */
  suggestions?: {
    /** Lists variants that were set by the consuming system to the indicated values but which could not be set these values due to conflicts. This property will presumably only be set if the response corresponds to a change variant request in which conflicting changes are not to be applied immediately. */
    failedCommits?: VariantList;
    /** Describes required changes in the current vehicle configuration in terms of variant modifications. This property will presumably only be set if the response corresponds to a change variant request in which conflicting changes are not to be applied immediately. */
    requiredChanges?: {
      /** Variant in the current configuration that is up for replacement. */
      currentVariant?: ProductVariant;
      /** Information about the family of the variant that needs to be changed */
      productFamily?: {
        id?: ProductFamilyId;
        title?: ProductFamilyTitle;
      };
      /** The variant that is to replace the current variant. */
      replacementVariant?: ProductVariant;
    }[];
    /** Lists pinned variants that would be violated if the user-selected variants would have been applied */
    violatedPins?: VariantList;
  };
};
export type CorrelationId = string;
export type EcmSignalStatus = "Green" | "Yellow" | "Red";
export type BaseCheckResponse = StatusResponse & {
  correlationId?: CorrelationId;
  /** Indicates if the requested check was disabled for this configuration. If true, no check result will be returned */
  disabled?: boolean;
  /** Indicates if the requested check was disabled for this configuration. If true, no check result will be returned */
  elapsedMilliseconds?: number;
  /** Probably indicates if there was some problem when connecting to the service that conducts the check */
  isConnectionError?: boolean;
  signalStatus?: EcmSignalStatus;
};
export type BrakeCheckResponse = BaseCheckResponse & {
  /** Detailed description of the brake check. Note that this field will be missing if brake checking for this configuration was disabled which can be done in the SECM Admin Tool */
  content?: {
    axle?: {
      usedRearAxleIndexes?: number[];
    };
    brakeRatio?: {
      legalMinimum?: number;
      value?: number;
    };
    brakeRatioDemandFulfilled?: boolean;
    unladenWeightDemandFulfilled?: boolean;
    weight?: {
      legalMinimum?: number;
      unladen?: number;
    };
  };
  messages?: any;
};
export type CheckErrorResponse = StatusResponse & {
  correlationId?: CorrelationId;
  error?: string;
  /** Further details about the error */
  metadata?: {
    [key: string]: any;
  };
};
export type DvsCheckResponse = BaseCheckResponse & {
  /** Detailed description of the Direct Vision Standard test. Note that this field will be missing if brake checking for this configuration was disabled which can be done in the SECM Admin Tool */
  content?: {
    remainingHeightToNextRating?: string;
    starRating?: number;
  };
  hasErrors?: boolean;
  messages?: any;
};
export type OasMessages = {
  categoryID?: number;
  comment?: string;
  description?: string;
  id?: number;
  messageGroup?: string;
  text?: string;
}[];
export type OasCheckResponse = BaseCheckResponse & {
  oasResult?: {
    errors?: OasMessages;
    informations?: OasMessages;
    messages?: OasMessages;
    warnings?: OasMessages;
  };
  partPeriod?: Period;
};
export type OasCheckType = "extended" | "tcr_vcr";
export type TireCheckResponse = BaseCheckResponse & {
  /** Represents the content details of a tyre check result */
  content?: {
    /** Contains an FPC code representing a country */
    countryDetails?: {
      /** Textual description of the country code */
      description?: string;
      family?: ProductFamilyId;
      variant?: ProductVariantId;
    };
    /** ECM publish date */
    ecmPublishDate?: string;
    /** Some ECM revision number */
    revision?: string;
    tyreDetails?: {
      /** Textual description of the tire */
      description?: string;
      family?: ProductFamilyId;
      /** The tyirs content statuses: UNDEFINED - The tyre content was not defined OK - The tire content is OK. FAILED - The tire content has failed. NOT_FOUND - The tire content was not found */
      status?: "UNDEFINED" | "OK" | "FAILED" | "NOT_FOUND";
      /** Specifies the tire's/tires' position(s) in the vehicle */
      tyrePosition?: string;
      variant?: ProductVariantId;
    }[];
  };
  hasErrors?: boolean;
  messages?: any;
};
export type WeightCheckResponse = BaseCheckResponse & {
  /** Detailed description of the weight check. Note that this field will be missing if brake checking for this configuration was disabled which can be done in the SECM Admin Tool */
  content?: {
    frontAxleWeight?: number;
    rearAxleWeight?: number;
    totalWeight?: number;
  };
  hasErrors?: boolean;
  messages?: {
    content?: string;
    messageType?: string;
    referenceIndex?: string;
  }[];
};
export type ConfigurationStepDataOptions = {
  /** Indicates whether the current vehicle configuration should be returned */
  returnCurrentConfiguration?: boolean;
};
export type VariantSelectionOptions = ConfigurationStepDataOptions & {
  /** Indicates if the selected variant is in conflict with previously selected variants, the solution proposed by the solver to overcome this conflict should be directly applied or if the consuming system should only be informed about suggested changes without applying them. Note however that in the latter case the returned suggestions will deviate from what will actually be changed. */
  autoApplyConflictingChanges?: boolean;
  /** Indicates if the provided variants are to be added to the vehicle configuration one after the other or if they should be added all at once. The choice of this flag might have a severe impact. If two variants are given that cannot be part of the same configuration, consecutive application in conjunction with autoApplyConflictingChanges=True will first add one variant to the vehicle. This variant will then be removed again before the second variant is added. All-at-once application on the other hand will fail and return an error message indicating the conflicting variants. If autoApplyConflictingChanges=False the result for consecutive and all-at-once application will be similar and no changes will occur. If the given variants are however compatible with each other, both application schemes should yield similar results. Note: If option pinning is used, select_variants_consecutively must be set to False, as there is currently no other way to make pinning work. Also not that if select_variants_consecutively is set to True, the order of the variants designated for selection might influence the final result. */
  select_variants_consecutively?: boolean;
};
export type MultiVariantDeselectionRequest = VariantSelectionOptions & {
  /** List of variants that are to be deselected. */
  variantsForDeselection?: VariantList;
};
export type RefreshConfigurationResponse = StatusResponse & {
  /** Indicates if the refresh was successful */
  refreshed?: boolean;
  uuid?: EcmConfigId & string;
};
export type MultiVariantSelectionRequest = VariantSelectionOptions & {
  /** List of variants in the current configuration that must not be changed */
  pinnedVariants?: VariantList;
  /** List of variants that are to be selected. Note that if select_variants_consecutively=True is used, the order of the variants might have an impact in the selection result, especially of one or more of variants are incompatible with each other. */
  variantsForSelection?: VariantList;
};
export type StepId = number;
export type ChangedVariantList = {
  familyId?: ProductFamilyId;
  newVariantId?: ProductVariantId;
  oldVariantId?: ProductVariantId;
}[];
export type EcmConfiguratorStatus =
  | "Ok"
  | "OkPartial"
  | "ConfiguratorChangesNeeded"
  | "ConfiguratorCommitsFailed"
  | "ConfiguratorError"
  | "ConfiguratorException"
  | "ConfiguratorStepchangeFailed"
  | "ConfiguratorTimeout"
  | "OperationNotAllowed"
  | "UnspecifiedApplicationError";
export type SwitchBaseParametersResponse = StatusResponse & {
  changedVariants?: ChangedVariantList & any;
  newConfigStatus?: EcmConfiguratorStatus & string;
  newUuid?: EcmConfigId & string;
  newVariants?: VariantList & any;
  removedVariants?: VariantList & any;
};
export type SwitchBaseParametersRequest = {
  /** ECM base parameters of the new configuration. Apart from the required properties, make sure to include either confirmedPartPeriod or desiredDealerDate */
  ecmParameters?: {
    configurationTypeID: ConfigTypeId;
    confirmedPartPeriod?: Period;
    desiredDealerDate?: DesiredDealerDate;
    languageID: LanguageId;
    marketID: MarketId;
    vehicleTypeID: VehicleTypeId;
    viewID: ViewId;
  };
};
export type ValidationResponse = {
  valid?: boolean;
  validationResult?: {
    description?: string;
    returnCode?: number;
    source?:
      | "Document"
      | "VariantCode"
      | "Family"
      | "Denomination"
      | "PriceList"
      | "PriceListHeader"
      | "Other";
  }[];
};
export type OasRenderProvision = StatusResponse & {
  /** Serialized XML representation of vehicle provision that allows computation of vehicle break down via OAS */
  oasBreakDownInput?: string;
};
export type ConvertEcmConfigResponse = ManCodeResponse | OasRenderProvision;
export type EcmConversionTarget = {
  additionalInformation: {
    /** ECM base parameters of the configuration that is to be converted */
    ecmParameters: {
      configurationTypeId?: ConfigTypeId;
      languageId: LanguageId;
      marketId: MarketId;
      vehicleTypeId: VehicleTypeId;
      viewId: ViewId;
    };
  };
  /** Indicates whether to include FPC code attribute in the resulting MAN Code */
  includeAttributes?: boolean;
  /** Indicates the desired target representation */
  targetFormat: "MAN_CODE" | "OAS_RENDER_PROVISION_INPUT";
};
export type ManCodeEcmConversionResponse = {
  ecmConfigId?: EcmConfigId;
};
export type CavaInput = {
  VehicleData?: {
    Provision?: {
      Fpc?: FlattenedFpcCode[];
      PartPeriod?: Period;
    };
  };
};
export type ManCodeCavaInputConversionResponse = {
  cavaInput?: CavaInput;
};
export type ManCodeOasvSpecInputConversionResponse = {
  /** XML blob containing request body for an OAS request */
  oasVSpecInput?: string;
};
export type ManCodeConversionResponse = StatusResponse & {
  conversionResult?:
    | ManCodeEcmConversionResponse
    | ManCodeCavaInputConversionResponse
    | ManCodeOasvSpecInputConversionResponse;
};
export type TargetFormat = "ECM";
export type EcmSpecificConversionParameters = {
  ecmParametersOverwrites?: {
    configurationTypeId?: ConfigTypeId;
    languageId?: LanguageId;
    marketId?: MarketId;
    targetFormat?: TargetFormat;
    vehicleTypeId?: VehicleTypeId;
    viewId?: ViewId;
  };
  partPeriodOverwrite?: Period;
};
export type OasSpecificConversionParameters =
  EcmSpecificConversionParameters & {
    /** Attribute defining validity of the ECO timestamps. Possible values are: 1. preliminary - time is defined by the CP responsible, and is used to analyze the product structure during development. 2. definitive - time is defined by the time setters (Info from SCANIA) */
    coTimeValidity?: "definitive" | "preliminary";
    /** Denotes the vehicle's root code */
    startObject?: string;
    targetFormat?: TargetFormat;
    /** Unknown parameter */
    validationModes?: "COMPLETE";
  };
export type CavaSpecificConversionParameters =
  EcmSpecificConversionParameters & {
    targetFormat?: TargetFormat;
  };
export type ManConversionTarget = {
  formatSpecificParameters?:
    | EcmSpecificConversionParameters
    | OasSpecificConversionParameters
    | CavaSpecificConversionParameters;
  manCode: ManCode;
  targetFormat: TargetFormat;
};
export type ManCodeIdToGdcConversionResponse = StatusResponse & {
  /** Complete vehicle specification in terms of FPC codes without codes that are incompatible with GDC requests */
  provision: string;
  /** Weights required as input for GDC requests */
  weights: {
    /** Front axle load in kg as provided by CAVA */
    axleLoadFront: number;
    /** Rear axle load in kg as provided by CAVA */
    axleLoadRear: number;
    /** Total axle load in kg as provided by CAVA */
    totalWeight?: number;
  };
};
export type AddOnCode = {
  /** Identifies the add-on's family */
  category?: string;
  /** Identifies the link to the add-on's family */
  categoryLink?: string;
  /** Textual description of the add-on's family */
  categoryText?: string;
  /** Unique add-on identifier */
  code?: string;
  /** The add-on's gross price */
  grossPrice?: number;
  /** Textual description of the add-on */
  text?: string;
};
export type TitledAddOnCode = AddOnCode & {
  /** Textual add-on code description as derived from Data4MAN. Note that this description might vary from the one contained in the property 'text' */
  title?: string;
};
export type ExtraEquipment = {
  /** Unique extra equipment item identifier */
  code: string;
  /** Gross price of the extra equipment item */
  grossPrice?: number;
  /** Textual description of the extra equipment item */
  message?: string;
  printingOptions?: PrintingOptions;
  /** Type of the equipment */
  type?: "customerSpecialRequest" | "manIndividualTruck" | "";
};
export type TitledExtraEquipment = ExtraEquipment & {
  /** Textual extra equipment code description as derived from Data4MAN. Note that this description might vary from the one contained in the property 'message'. */
  title?: string;
};
export type BaseLegacyOption = {
  grossListPrice?: CodeGrossListPrice;
  hideCode?: CodeHideCode;
  pictureIndex?: PictureIndex;
  printingOptions?: PrintingOptions;
  topOption?: CodeTopOption;
  withoutCode?: CodeWithoutCode;
};
export type FactoryVCode = BaseLegacyOption & {
  /** Option ID */
  code?: string;
  driveTrainRecommendation?: boolean;
  /** If true, this option is not shown in the configurator (wrong spelling is due to compatibility reasons) */
  ineffectivForSales?: boolean;
  /** (Wrong spelling is due to compatibility reasons) */
  noDisplayOfAbsolutPrice?: boolean;
};
export type LegacyProductFactoryVariant = FactoryVCode & {
  /** Language-specific variant description */
  title?: string;
};
export type LegacyNationalProductGroup = {
  nationalCodes?: LegacyProductFactoryVariant[];
  /** Language-specific description of national product group */
  title?: string;
};
export type PaintInformation = {
  /** Identifies the colour */
  colour?: string;
  /** Identifies of the paint zone */
  paintZone?: string;
  /** Identifies the paint quality */
  quality?: string;
};
export type TitledPaintInformation = PaintInformation & {
  /** Textual paint code description as derived from Data4MAN. */
  title?: string;
};
export type LegacyProductBaseFamily = {
  hasDetailData?: boolean;
  /** Family ID ('Gattung') */
  id: string;
  /** Index of selected variant in this family */
  selectedVariantIndex?: number;
  /** Language specific family description */
  title: string;
  /** Number of variants in this family */
  totalVariantCount: number;
};
export type LegacyProductFactoryFamily = LegacyProductBaseFamily & {
  variants?: LegacyProductFactoryVariant[];
};
export type LegacyProductSubgroup = {
  families?: LegacyProductFactoryFamily[];
  id: string;
  /** Language specific subgroup description */
  title: string;
};
export type LegacyProductGroup = {
  /** Reference to corresponding group in ECM view */
  ecm?: {
    /** Indicates how confident one should be in the established correspondence to the ECM group (0.0 no confidence - 1.0 full confidence) */
    confidence?: number;
    /** ID of ECM group that most closely corresponds to this legacy C4S group */
    groupReference?: string;
  };
  id: string;
  subGroups?: LegacyProductSubgroup[];
  /** Language specific group description */
  title: string;
};
export type RucksackOption = {
  /** TG3 option ID */
  code?: string;
  grossListPrice?: CodeGrossListPrice;
};
export type TitledRucksackOption = RucksackOption & {
  /** Textual rucksack code description as derived from Data4MAN */
  title?: string;
};
export type LegacyManCodeId = string;
export type CodeTransformationResult = {
  /** Value between 0.0 and 1.0 indicating the quality of the match */
  confidence?: number;
  /** Set of FPC-codes to which a set of V-codes was mapped. */
  fpcCodes?: FlattenedFpcCode[];
  /** Mapping from V-codes to FPC families. If the array containing FPC codes is empty but this mapping has content, then no automated mapping could be established, but a manual mapping to variants from the listed FPC families should be conducted be the user. Note that this map makes no sense for n:m mappings. We are in contact with the developers to get this straight, it will probably change at some point in the future. */
  fpcFamilies?: {
    [key: string]: string;
  };
  infos?: string[];
  /** Mapping from V-codes to lock status as given in the input TG3 MANCode. This information is more or less useless, as it just returns the input. Might remove this later. */
  locks?: {
    [key: string]: "LOCKED" | "USER_LOCK" | "CLOSED";
  };
  /** Set of V-codes that are mapped to a set of FPC-codes */
  tg3VCodes?: string[];
  /** Mapping from V-codes involved in this match to their respective shell. The lower the shell value, the more important the code is for the overall vehicle configuration */
  transformationTiers?: {
    [key: string]: string;
  };
};
export type LegacyConversionServiceResponse = {
  code?: LegacyManCodeId;
  codeTransformationResults?: CodeTransformationResult[];
  /** Textual description of errors that occured during conversion */
  errors?: string[];
  metadata?: {
    [key: string]: string;
  };
};
export type Tg3ToMaicConversionResponse = StatusResponse & {
  addOnCodes?: TitledAddOnCode[];
  extraEquipments?: TitledExtraEquipment[];
  marketDenomination?: MarketDenomination;
  nationalProductGroups?: LegacyNationalProductGroup[];
  paintInformation?: TitledPaintInformation;
  productGroups?: LegacyProductGroup[];
  rucksack?: TitledRucksackOption[];
  vCodesToFPCCodes?: LegacyConversionServiceResponse;
  /** Textual description of problems that occurred during conversion */
  warnings?: string[];
};
export type NationalVCode = BaseLegacyOption & {
  classification?: NatCodeClassification;
  /** Option ID */
  code?: string;
  commissionRelevant?: NatCodeCommissionRelevant;
  condition?: NatCodeCondition;
  currency?: NatCodeCurrency;
  /** Not clear what this is */
  noCode?: boolean;
  orderRelevant?: NatCodeOrderRelevant;
};
export type TechnicalData = {
  keyValuePairs?: KeyValuePairList;
};
export type LegacyVehicleConfiguration = {
  /** List of codes that are added by AVIS / VMS due to KSW / MSW */
  addOnCodes?: AddOnCode[];
  /** List of extra equipment items */
  extraEquipments?: ExtraEquipment[];
  /** List of TG3 factory codes */
  factoryVCodes?: FactoryVCode[];
  /** List of TG3 national codes */
  nationalVCodes?: NationalVCode[];
  orderCountry?: OrderCountry;
  /** Describes which paints to apply to different parts of the vehicle */
  paintInformation?: PaintInformation[];
  /** List of options that need to be added back to the vehicle in order to make it buildable again */
  rucksack?: RucksackOption[];
  /** Target delivery date (Sollliefertermin Region) */
  slr?: string;
  specialRequest?: SpecialRequest;
  technicalData?: TechnicalData;
  vehicleDescription?: VehicleDescription;
};
export type LegacyManCode = {
  code?: LegacyManCodeId;
  configuration?: LegacyVehicleConfiguration;
  insertTimestamp?: ZonedDateTime;
  manCodeObjectVersion?: ManCodeObjectVersion;
  tokens?: SystemTokens;
  updateTimestamp?: ZonedDateTime;
};
export type Tg3ConversionRequest = {
  targetFormat?: "MAIC";
  tg3Code: LegacyManCode;
};
export type ConfigType = {
  configTypeID?: ConfigTypeId;
  /** Textual configuration type description */
  configTypeName?: string;
};
export type ConfigTypeInfo = StatusResponse & {
  /** List of information on available ECM configuration types */
  listOfConfigTypes?: ConfigType[];
};
export type VehicleType = {
  vehicleTypeID?: VehicleTypeId;
  /** Textual vehicle type description */
  vehicleTypeName?: string;
};
export type VehicleTypeInfo = StatusResponse & {
  /** List of information on available ECM vehicle types */
  listOfVehicleTypes?: VehicleType[];
};
export type ViewHeader = {
  viewID?: ViewId;
  /** Textual description of view header */
  viewName?: string;
};
export type ViewHeaderInfo = StatusResponse & {
  /** List of information on view headers */
  listOfViewHeader?: ViewHeader[];
};
export type ImportantFamiliesFactoryResponse = StatusResponse & {
  importantFamilies?: ImportantFamilies;
};
export type ListOfFamily = {
  /** List of the families executions. Source: ECM */
  executions?: {
    /** Readable execution name */
    executionDescription?: string;
    /** Execution identifier */
    executionName?: string;
  }[];
  /** Readable family name */
  familyDescription?: string;
  familyName?: ProductFamilyId;
}[];
export type ListOfMainHeaders = {
  /** List of the headers subheaders. Source: ECM */
  listOfSubHeaders?: {
    listOfFamily?: ListOfFamily;
    /** Readable header name */
    subHeaderDescription?: string;
    subHeaderNo?: number;
  }[];
  /** Readable header name */
  mainHeaderDescription?: string;
  mainHeaderNo?: number;
}[];
export type FamiliesTreeResponseBody = {
  listOfMainHeaders: ListOfMainHeaders;
  response_type: string;
};
export type FamiliesFlatResponseBody = {
  listOfFamily?: ListOfFamily;
  response_type: string;
};
export type AllFamiliesResponse = StatusResponse & {
  families_result?: FamiliesTreeResponseBody | FamiliesFlatResponseBody;
};
export type LanguageInfo = {
  isoCountryCode?: CountryIsoCode;
  languageID?: LanguageId;
  languageISOId?: LanguageIsoCode;
  /** Textual description of the language */
  languageName?: string;
};
export type MarketLanguages = StatusResponse & {
  listOfLanguage?: LanguageInfo[];
};
export type DddToPpResponse = StatusResponse & {
  partPeriod?: Period;
};
export type LegacyManCodeResponse = StatusResponse & {
  tg3Code?: LegacyManCode;
};
export type Market = {
  /** List of of configuration type IDs that are available for this market. Note that this list is currently not fetched from ECM but is built from static data that might not be up-to-date. */
  configurationTypeIDs?: ConfigTypeId[];
  /** Indicates whether this market is an aggregation of sub-markets */
  isBusinessUnit?: boolean;
  /** Hints at the country this market represents, but might also not. Some markets have country code XQ, which seems to be some sort of meta-country e.g. for business units */
  isoCountryCode?: string;
  marketId?: MarketId;
  /** Textual market description */
  marketName?: string;
  vehicleTypeID?: VehicleTypeId;
};
export type MarketInfo = StatusResponse & {
  /** List of available markets */
  markets?: Market[];
};
export type FavoriteEntry = {
  createdAt?: number;
  id?: string;
};
export type Favorite = {
  createdAt?: number;
  entries?: FavoriteEntry[];
  id?: string;
  name?: string;
};
export type Favorites = {
  activeFavoriteSetId?: string;
  favoriteSets?: Favorite[];
};
export type UserManCode = {
  createdAt?: number;
  deliveryDate?: string;
  lastUsedAt?: number;
  manCode?: string;
  marketDenomination?: string;
  /** Part Period in frontend specific format */
  partPeriod?: string;
  title?: string;
};
export type RecentManCodes = {
  manCodes?: UserManCode[];
};
export type UserDataObject = {
  __maicVersion?: string;
  __type?: string;
  __updatedAt?: number;
  __version?: string;
  favorites?: Favorites;
  recentManCodes?: RecentManCodes;
};
export type UserData = StatusResponse & {
  userData?: UserDataObject;
};
export type VisImageReady = {
  outcome: "IMAGE_READY";
  url: string;
};
export type VisFetchCode = string;
export type VisImagePending = {
  fetch_code: VisFetchCode;
  outcome: "IMAGE_PENDING";
};
export type VisBadRequest = {
  outcome: "ERROR";
};
export type VisOrderRequest = {
  /** A TG3 config string in the format PPPPPP@@VCODE+VCODE+...+VCODE_PAINT+... */
  configstring?: string;
  legacy_vehicle_configuration?: LegacyVehicleConfiguration;
};
